import * as React from 'react'

function SvgEs(props) {
	return (
		<svg viewBox="0 0 750 500" width="1em" height="1em" {...props}>
			<path fill="#c60b1e" d="M0 0h750v500H0z" />
			<path fill="#ffc400" d="M0 125h750v250H0z" />
			<path
				d="M167.99 222.24s-.51 0-.8-.16c-.27-.16-1.12-.96-1.12-.96l-.68-.49-.62-.85s-.73-1.18-.4-2.09c.34-.9.9-1.23 1.42-1.5.5-.26 1.58-.59 1.58-.59s.85-.37 1.13-.42c.28-.06 1.3-.33 1.3-.33s.28-.15.56-.26c.29-.1.68-.1.9-.16.23-.06.8-.24 1.14-.26.52-.02 1.35.1 1.64.1.28 0 1.24.05 1.64.05.39 0 1.8-.1 2.2-.1.4 0 .68-.06 1.13 0 .45.05 1.24.31 1.47.42.23.1 1.58.6 2.1.75.5.16 1.74.37 2.31.64.56.27.9.72 1.19 1.1.28.37.34.78.45 1.05.1.26.11.84 0 1.1-.11.27-.51.82-.51.82l-.62 1.02-.8.64s-.56.54-1 .48c-.46-.05-5.04-.86-7.98-.86-2.94 0-7.63.86-7.63.86"
				fill="#ad1519"
			/>
			<path
				d="M167.99 222.24s-.51 0-.8-.16c-.27-.16-1.12-.96-1.12-.96l-.68-.49-.62-.85s-.73-1.18-.4-2.09c.34-.9.9-1.23 1.42-1.5.5-.26 1.58-.59 1.58-.59s.85-.37 1.13-.42c.28-.06 1.3-.33 1.3-.33s.28-.15.56-.26c.29-.1.68-.1.9-.16.23-.06.8-.24 1.14-.26.52-.02 1.35.1 1.64.1.28 0 1.24.05 1.64.05.39 0 1.8-.1 2.2-.1.4 0 .68-.06 1.13 0 .45.05 1.24.31 1.47.42.23.1 1.58.6 2.1.75.5.16 1.74.37 2.31.64.56.27.9.72 1.19 1.1.28.37.34.78.45 1.05.1.26.11.84 0 1.1-.11.27-.51.82-.51.82l-.62 1.02-.8.64s-.56.54-1 .48c-.46-.05-5.04-.86-7.98-.86-2.94 0-7.63.86-7.63.86z"
				fill="none"
				stroke="#000"
				strokeLinejoin="round"
				strokeWidth={0.26}
			/>
			<path
				d="M174.28 215.68c0-1.38.62-2.5 1.38-2.5.76 0 1.38 1.12 1.38 2.5s-.62 2.5-1.38 2.5c-.76 0-1.38-1.12-1.38-2.5"
				fill="#c8b100"
			/>
			<path
				d="M174.28 215.68c0-1.38.62-2.5 1.38-2.5.76 0 1.38 1.12 1.38 2.5s-.62 2.5-1.38 2.5c-.76 0-1.38-1.12-1.38-2.5z"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M175.05 215.68c0-1.27.28-2.3.63-2.3s.64 1.03.64 2.3c0 1.26-.28 2.3-.64 2.3-.35 0-.63-1.04-.63-2.3"
				fill="#c8b100"
			/>
			<path
				d="M175.05 215.68c0-1.27.28-2.3.63-2.3s.64 1.03.64 2.3c0 1.26-.28 2.3-.64 2.3-.35 0-.63-1.04-.63-2.3z"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M174.75 213.04a.9.9 0 01.93-.87c.5 0 .92.4.92.87 0 .49-.41.87-.92.87-.52 0-.93-.38-.93-.87"
				fill="#c8b100"
			/>
			<path
				d="M176.33 212.74v.58h-1.43v-.58h.47v-1.31h-.62v-.58h.62v-.57h.6v.57h.62v.58h-.62v1.3h.36"
				fill="#c8b100"
			/>
			<path
				d="M176.33 212.74v.58h-1.43v-.58h.47v-1.31h-.62v-.58h.62v-.57h.6v.57h.62v.58h-.62v1.3h.36"
				fill="none"
				stroke="#000"
				strokeWidth={0.3}
			/>
			<path
				d="M176.97 212.74v.58h-2.54v-.58h.94v-1.31h-.62v-.58h.62v-.57h.6v.57h.62v.58h-.62v1.3h1"
				fill="#c8b100"
			/>
			<path
				d="M176.97 212.74v.58h-2.54v-.58h.94v-1.31h-.62v-.58h.62v-.57h.6v.57h.62v.58h-.62v1.3h1"
				fill="none"
				stroke="#000"
				strokeWidth={0.3}
			/>
			<path
				d="M175.94 212.2c.38.1.66.45.66.84 0 .49-.41.87-.92.87-.52 0-.93-.38-.93-.87 0-.4.3-.75.69-.84"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M175.68 222.08h-4.8l-.12-1.18-.23-1.23-.24-1.53c-1.32-1.75-2.54-2.9-2.95-2.65.1-.32.22-.56.47-.71 1.18-.7 3.6.98 5.44 3.74.16.25.32.5.46.75h3.97c.14-.25.3-.5.46-.75 1.83-2.76 4.26-4.44 5.43-3.74.26.15.37.39.47.71-.4-.24-1.62.9-2.95 2.65l-.24 1.53-.23 1.23-.1 1.18h-4.84"
				fill="#c8b100"
			/>
			<path
				d="M175.68 222.08h-4.8l-.12-1.18-.23-1.23-.24-1.53c-1.32-1.75-2.54-2.9-2.95-2.65.1-.32.22-.56.47-.71 1.18-.7 3.6.98 5.44 3.74.16.25.32.5.46.75h3.97c.14-.25.3-.5.46-.75 1.83-2.76 4.26-4.44 5.43-3.74.26.15.37.39.47.71-.4-.24-1.62.9-2.95 2.65l-.24 1.53-.23 1.23-.1 1.18h-4.84z"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M167.55 215.44c.9-.53 3.02 1.15 4.73 3.74m11.55-3.74c-.9-.53-3.01 1.15-4.73 3.74"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M168.58 224.25c-.2-.57-.58-1.08-.58-1.08a28.7 28.7 0 017.67-.94c3.01 0 5.75.37 7.69.94l-.52.91c-.17.3-.39.81-.38.81a23.8 23.8 0 00-6.8-.82c-2.79 0-5.46.35-6.86.86.02 0-.1-.32-.23-.68"
				fill="#c8b100"
			/>
			<path
				d="M168.58 224.25c-.2-.57-.58-1.08-.58-1.08a28.7 28.7 0 017.67-.94c3.01 0 5.75.37 7.69.94l-.52.91c-.17.3-.39.81-.38.81a23.8 23.8 0 00-6.8-.82c-2.79 0-5.46.35-6.86.86.02 0-.1-.32-.23-.68"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M175.67 226.73c2.43 0 5.11-.38 6.1-.63.66-.2 1.05-.5.98-.84-.04-.16-.18-.3-.37-.38-1.46-.47-4.07-.8-6.7-.8-2.65 0-5.28.33-6.73.8-.19.08-.33.22-.36.38-.08.35.31.65.97.84.99.25 3.68.62 6.11.63"
				fill="#c8b100"
			/>
			<path
				d="M175.67 226.73c2.43 0 5.11-.38 6.1-.63.66-.2 1.05-.5.98-.84-.04-.16-.18-.3-.37-.38-1.46-.47-4.07-.8-6.7-.8-2.65 0-5.28.33-6.73.8-.19.08-.33.22-.36.38-.08.35.31.65.97.84.99.25 3.68.62 6.11.63z"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M183.48 222.08l-.6-.53s-.56.34-1.27.24c-.7-.11-.93-.97-.93-.97s-.8.67-1.44.62a1.7 1.7 0 01-1.07-.62s-.7.5-1.33.46c-.62-.06-1.21-.83-1.21-.83s-.63.8-1.25.86c-.62.05-1.13-.54-1.13-.54s-.28.59-1.07.72c-.8.13-1.47-.62-1.47-.62s-.45.73-.99.92c-.53.18-1.24-.27-1.24-.27l-.2.43c-.09.16-.31.19-.31.19l.18.47c1.93-.56 4.56-.9 7.53-.9 2.97 0 5.67.34 7.61.9l.2-.53"
				fill="#c8b100"
			/>
			<path
				d="M183.48 222.08l-.6-.53s-.56.34-1.27.24c-.7-.11-.93-.97-.93-.97s-.8.67-1.44.62a1.7 1.7 0 01-1.07-.62s-.7.5-1.33.46c-.62-.06-1.21-.83-1.21-.83s-.63.8-1.25.86c-.62.05-1.13-.54-1.13-.54s-.28.59-1.07.72c-.8.13-1.47-.62-1.47-.62s-.45.73-.99.92c-.53.18-1.24-.27-1.24-.27l-.2.43c-.09.16-.31.19-.31.19l.18.47c1.93-.56 4.56-.9 7.53-.9 2.97 0 5.67.34 7.61.9l.2-.53z"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M175.69 219.5l.28.04a1.09 1.09 0 001.06 1.43c.5 0 .91-.3 1.06-.73.01.01.1-.38.15-.38.03 0 .03.41.05.4.07.53.55.9 1.1.9.62 0 1.1-.47 1.1-1.06v-.12l.35-.35.2.44a.9.9 0 00-.11.46c0 .56.47 1 1.06 1 .37 0 .7-.17.88-.44l.23-.29v.35c0 .35.15.66.49.72 0 0 .38.03.9-.38.52-.41.81-.75.81-.75l.03.42s-.5.84-.97 1.1c-.25.15-.64.3-.95.25-.32-.04-.55-.3-.67-.6-.23.13-.5.21-.8.21-.63 0-1.2-.35-1.42-.86a1.62 1.62 0 01-2.42-.08 1.63 1.63 0 01-2.43-.26 1.62 1.62 0 01-2.42.26 1.63 1.63 0 01-2.42.08c-.22.5-.79.86-1.42.86-.29 0-.56-.08-.8-.22-.11.3-.34.56-.67.61-.3.06-.69-.1-.94-.25-.47-.26-1.02-1.1-1.02-1.1l.07-.42s.3.34.8.75c.53.41.92.38.92.38.34-.06.49-.37.49-.72v-.35l.22.29c.19.27.51.45.88.45.59 0 1.06-.45 1.06-1.01a.94.94 0 00-.1-.46l.2-.44.34.35-.01.12c0 .59.5 1.06 1.11 1.06.55 0 1.03-.37 1.1-.9.02.01.02-.4.05-.4.05 0 .14.4.16.38.14.42.56.73 1.06.73a1.09 1.09 0 001.06-1.43l.29-.05"
				fill="#c8b100"
			/>
			<path
				d="M175.69 219.5l.28.04a1.09 1.09 0 001.06 1.43c.5 0 .91-.3 1.06-.73.01.01.1-.38.15-.38.03 0 .03.41.05.4.07.53.55.9 1.1.9.62 0 1.1-.47 1.1-1.06v-.12l.35-.35.2.44a.9.9 0 00-.11.46c0 .56.47 1 1.06 1 .37 0 .7-.17.88-.44l.23-.29v.35c0 .35.15.66.49.72 0 0 .38.03.9-.38.52-.41.81-.75.81-.75l.03.42s-.5.84-.97 1.1c-.25.15-.64.3-.95.25-.32-.04-.55-.3-.67-.6-.23.13-.5.21-.8.21-.63 0-1.2-.35-1.42-.86a1.62 1.62 0 01-2.42-.08 1.63 1.63 0 01-2.43-.26 1.62 1.62 0 01-2.42.26 1.63 1.63 0 01-2.42.08c-.22.5-.79.86-1.42.86-.29 0-.56-.08-.8-.22-.11.3-.34.56-.67.61-.3.06-.69-.1-.94-.25-.47-.26-1.02-1.1-1.02-1.1l.07-.42s.3.34.8.75c.53.41.92.38.92.38.34-.06.49-.37.49-.72v-.35l.22.29c.19.27.51.45.88.45.59 0 1.06-.45 1.06-1.01a.94.94 0 00-.1-.46l.2-.44.34.35-.01.12c0 .59.5 1.06 1.11 1.06.55 0 1.03-.37 1.1-.9.02.01.02-.4.05-.4.05 0 .14.4.16.38.14.42.56.73 1.06.73a1.09 1.09 0 001.06-1.43l.29-.05z"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M175.67 222.23c-3.01 0-5.72.37-7.67.94-.13.04-.29-.06-.33-.17-.04-.13.05-.28.18-.32 1.95-.6 4.73-.97 7.82-.98 3.09 0 5.88.38 7.83.98.13.04.22.2.18.32-.04.11-.2.21-.33.17a28.45 28.45 0 00-7.68-.94"
				fill="#c8b100"
			/>
			<path
				d="M175.67 222.23c-3.01 0-5.72.37-7.67.94-.13.04-.29-.06-.33-.17-.04-.13.05-.28.18-.32 1.95-.6 4.73-.97 7.82-.98 3.09 0 5.88.38 7.83.98.13.04.22.2.18.32-.04.11-.2.21-.33.17a28.45 28.45 0 00-7.68-.94z"
				fill="none"
				stroke="#000"
				strokeLinejoin="round"
				strokeWidth={0.26}
			/>
			<path
				d="M172.75 223.3c0-.22.2-.4.44-.4s.44.18.44.4c0 .23-.2.41-.44.41s-.44-.18-.44-.4"
				fill="#fff"
			/>
			<path
				d="M172.75 223.3c0-.22.2-.4.44-.4s.44.18.44.4c0 .23-.2.41-.44.41s-.44-.18-.44-.4z"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M175.7 223.48h-.96c-.18 0-.33-.14-.33-.31 0-.17.14-.3.32-.3h1.96c.19 0 .33.13.33.3 0 .17-.15.31-.33.31h-.98"
				fill="#ad1519"
			/>
			<path
				d="M175.7 223.48h-.96c-.18 0-.33-.14-.33-.31 0-.17.14-.3.32-.3h1.96c.19 0 .33.13.33.3 0 .17-.15.31-.33.31h-.98"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M170.85 223.81l-.7.1a.318.318 0 01-.37-.25.3.3 0 01.27-.35l.7-.1.71-.11c.18-.02.34.09.37.25.02.17-.1.33-.27.35l-.71.11"
				fill="#058e6e"
			/>
			<path
				d="M170.85 223.81l-.7.1a.318.318 0 01-.37-.25.3.3 0 01.27-.35l.7-.1.71-.11c.18-.02.34.09.37.25.02.17-.1.33-.27.35l-.71.11"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path d="M168.05 224.3l.3-.5.66.13-.38.56-.58-.19" fill="#ad1519" />
			<path
				d="M168.05 224.3l.3-.5.66.13-.38.56-.58-.19"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M177.72 223.3c0-.22.2-.4.44-.4s.43.18.43.4c0 .23-.2.41-.43.41-.25 0-.44-.18-.44-.4"
				fill="#fff"
			/>
			<path
				d="M177.72 223.3c0-.22.2-.4.44-.4s.43.18.43.4c0 .23-.2.41-.43.41-.25 0-.44-.18-.44-.4z"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M180.5 223.81l.7.1c.17.03.34-.08.37-.25a.3.3 0 00-.27-.35l-.7-.1-.71-.11c-.18-.02-.34.09-.37.25-.03.17.1.33.27.35l.7.11"
				fill="#058e6e"
			/>
			<path
				d="M180.5 223.81l.7.1c.17.03.34-.08.37-.25a.3.3 0 00-.27-.35l-.7-.1-.71-.11c-.18-.02-.34.09-.37.25-.03.17.1.33.27.35l.7.11"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path d="M183.24 224.33l-.25-.53-.67.06.32.59.6-.12" fill="#ad1519" />
			<path
				d="M183.24 224.33l-.25-.53-.67.06.32.59.6-.12"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M175.66 226.16c-2.43 0-4.63-.22-6.3-.65 1.67-.43 3.87-.7 6.3-.7 2.44 0 4.65.27 6.33.7-1.68.44-3.9.65-6.33.65"
				fill="#ad1519"
			/>
			<path
				d="M175.66 226.16c-2.43 0-4.63-.22-6.3-.65 1.67-.43 3.87-.7 6.3-.7 2.44 0 4.65.27 6.33.7-1.68.44-3.9.65-6.33.65z"
				fill="none"
				stroke="#000"
				strokeLinejoin="round"
				strokeWidth={0.26}
			/>
			<path
				d="M183.34 220.88c.06-.18 0-.37-.13-.41-.14-.04-.3.08-.37.26-.06.19 0 .38.13.42.14.04.3-.08.37-.27"
				fill="#c8b100"
			/>
			<path
				d="M183.34 220.88c.06-.18 0-.37-.13-.41-.14-.04-.3.08-.37.26-.06.19 0 .38.13.42.14.04.3-.08.37-.27z"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M178.5 219.95c.02-.2-.08-.37-.22-.39-.14-.02-.28.13-.3.33-.02.2.07.37.21.38.14.02.28-.13.3-.32"
				fill="#c8b100"
			/>
			<path
				d="M178.5 219.95c.02-.2-.08-.37-.22-.39-.14-.02-.28.13-.3.33-.02.2.07.37.21.38.14.02.28-.13.3-.32z"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M172.87 219.95c-.03-.2.07-.37.21-.39.14-.02.28.13.3.33.03.2-.07.37-.21.38-.14.02-.28-.13-.3-.32"
				fill="#c8b100"
			/>
			<path
				d="M172.87 219.95c-.03-.2.07-.37.21-.39.14-.02.28.13.3.33.03.2-.07.37-.21.38-.14.02-.28-.13-.3-.32z"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M168.02 220.88c-.06-.18 0-.37.13-.41.14-.04.3.08.37.26.06.19 0 .38-.14.42-.13.04-.3-.08-.36-.27"
				fill="#c8b100"
			/>
			<path
				d="M168.02 220.88c-.06-.18 0-.37.13-.41.14-.04.3.08.37.26.06.19 0 .38-.14.42-.13.04-.3-.08-.36-.27z"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M175.66 217.15l-.85.52.63 1.38.22.14.22-.14.64-1.38-.86-.52"
				fill="#c8b100"
			/>
			<path
				d="M175.66 217.15l-.85.52.63 1.38.22.14.22-.14.64-1.38-.86-.52"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M173.78 219.24l.4.57 1.34-.42.14-.18-.15-.2-1.33-.39-.4.62"
				fill="#c8b100"
			/>
			<path
				d="M173.78 219.24l.4.57 1.34-.42.14-.18-.15-.2-1.33-.39-.4.62"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M177.55 219.24l-.39.57-1.34-.42-.14-.18.14-.2 1.34-.39.4.62"
				fill="#c8b100"
			/>
			<path
				d="M177.55 219.24l-.39.57-1.34-.42-.14-.18.14-.2 1.34-.39.4.62"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M170.08 217.76l-.67.64.86 1.14.23.09.17-.18.3-1.37-.89-.32"
				fill="#c8b100"
			/>
			<path
				d="M170.08 217.76l-.67.64.86 1.14.23.09.17-.18.3-1.37-.89-.32"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M168.67 220.04l.5.48 1.23-.66.1-.21-.18-.16-1.4-.13-.25.68"
				fill="#c8b100"
			/>
			<path
				d="M168.67 220.04l.5.48 1.23-.66.1-.21-.18-.16-1.4-.13-.25.68"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M172.36 219.3l-.26.63-1.4-.13-.18-.16.1-.21 1.22-.65.52.52"
				fill="#c8b100"
			/>
			<path
				d="M172.36 219.3l-.26.63-1.4-.13-.18-.16.1-.21 1.22-.65.52.52"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M167.32 220.22l-.11.66-1.4.15-.21-.12.05-.23 1.05-.87.62.41"
				fill="#c8b100"
			/>
			<path
				d="M167.32 220.22l-.11.66-1.4.15-.21-.12.05-.23 1.05-.87.62.41"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M170.02 219.65c0-.26.22-.47.5-.47.26 0 .48.21.48.47 0 .25-.22.46-.49.46a.48.48 0 01-.49-.46"
				fill="#c8b100"
			/>
			<path
				d="M170.02 219.65c0-.26.22-.47.5-.47.26 0 .48.21.48.47 0 .25-.22.46-.49.46a.48.48 0 01-.49-.46z"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M181.27 217.76l.67.64-.86 1.14-.23.09-.16-.18-.3-1.37.88-.32"
				fill="#c8b100"
			/>
			<path
				d="M181.27 217.76l.67.64-.86 1.14-.23.09-.16-.18-.3-1.37.88-.32"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M182.68 220.04l-.5.48-1.23-.66-.1-.21.19-.16 1.4-.13.24.68"
				fill="#c8b100"
			/>
			<path
				d="M182.68 220.04l-.5.48-1.23-.66-.1-.21.19-.16 1.4-.13.24.68"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path d="M179 219.3l.25.63 1.4-.13.18-.16-.1-.21-1.22-.65-.52.52" fill="#c8b100" />
			<path
				d="M179 219.3l.25.63 1.4-.13.18-.16-.1-.21-1.22-.65-.52.52"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M183.84 220.22l.11.66 1.4.15.21-.12-.05-.23-1.05-.87-.62.41"
				fill="#c8b100"
			/>
			<path
				d="M183.84 220.22l.11.66 1.4.15.21-.12-.05-.23-1.05-.87-.62.41"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M175.18 219.2c0-.25.22-.46.5-.46.26 0 .48.2.48.47 0 .25-.22.46-.49.46s-.49-.2-.49-.46"
				fill="#c8b100"
			/>
			<path
				d="M175.18 219.2c0-.25.22-.46.5-.46.26 0 .48.2.48.47 0 .25-.22.46-.49.46s-.49-.2-.49-.46z"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M180.36 219.65c0-.26.22-.47.49-.47s.49.21.49.47c0 .25-.22.46-.5.46a.48.48 0 01-.48-.46"
				fill="#c8b100"
			/>
			<path
				d="M180.36 219.65c0-.26.22-.47.49-.47s.49.21.49.47c0 .25-.22.46-.5.46a.48.48 0 01-.48-.46z"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M165.43 221c-.01 0-.38-.49-.66-.73-.2-.18-.67-.33-.67-.33 0-.09.28-.28.58-.28.18 0 .35.07.45.2l.04-.2s.24.05.36.32c.1.29.04.72.04.72s-.05.2-.14.3"
				fill="#c8b100"
			/>
			<path
				d="M165.43 221c-.01 0-.38-.49-.66-.73-.2-.18-.67-.33-.67-.33 0-.09.28-.28.58-.28.18 0 .35.07.45.2l.04-.2s.24.05.36.32c.1.29.04.72.04.72s-.05.2-.14.3z"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M165.45 220.75c.12-.12.36-.1.53.06.18.15.24.38.12.5-.12.13-.36.1-.53-.06-.18-.15-.24-.38-.12-.5"
				fill="#c8b100"
			/>
			<path
				d="M165.45 220.75c.12-.12.36-.1.53.06.18.15.24.38.12.5-.12.13-.36.1-.53-.06-.18-.15-.24-.38-.12-.5z"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M185.73 221c.01 0 .38-.49.66-.73.19-.18.67-.33.67-.33 0-.09-.28-.28-.58-.28a.58.58 0 00-.45.2l-.04-.2s-.24.05-.36.32c-.1.29-.03.72-.03.72s.04.2.13.3"
				fill="#c8b100"
			/>
			<path
				d="M185.73 221c.01 0 .38-.49.66-.73.19-.18.67-.33.67-.33 0-.09-.28-.28-.58-.28a.58.58 0 00-.45.2l-.04-.2s-.24.05-.36.32c-.1.29-.03.72-.03.72s.04.2.13.3z"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M185.74 220.75c-.11-.12-.35-.1-.53.06-.18.15-.24.38-.12.5.12.13.36.1.54-.06.18-.15.22-.38.11-.5"
				fill="#c8b100"
			/>
			<path
				d="M185.74 220.75c-.11-.12-.35-.1-.53.06-.18.15-.24.38-.12.5.12.13.36.1.54-.06.18-.15.22-.38.11-.5z"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path d="M164.58 232.37h22.29v-5.84h-22.29v5.84z" fill="#c8b100" />
			<path
				d="M164.58 232.37h22.29v-5.84h-22.29v5.84z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M166.92 236.26a.97.97 0 01.41-.07h16.7c.16 0 .31.03.44.08a1.4 1.4 0 01-.98-1.32c0-.6.45-1.14 1.03-1.33-.14.04-.33.08-.49.08h-16.7c-.17 0-.33-.01-.47-.06l.1.02c.59.18.93.71.93 1.3 0 .55-.38 1.12-.97 1.3"
				fill="#c8b100"
			/>
			<path
				d="M166.92 236.26a.97.97 0 01.41-.07h16.7c.16 0 .31.03.44.08a1.4 1.4 0 01-.98-1.32c0-.6.45-1.14 1.03-1.33-.14.04-.33.08-.49.08h-16.7c-.17 0-.33-.01-.47-.06l.1.02c.59.18.93.71.93 1.3 0 .55-.38 1.12-.97 1.3z"
				fill="none"
				stroke="#000"
				strokeLinejoin="round"
				strokeWidth={0.39}
			/>
			<path
				d="M167.33 236.2h16.7c.56 0 1.01.34 1.01.77 0 .44-.45.79-1.02.79h-16.69c-.56 0-1.02-.35-1.02-.79 0-.43.46-.78 1.02-.78"
				fill="#c8b100"
			/>
			<path
				d="M167.33 236.2h16.7c.56 0 1.01.34 1.01.77 0 .44-.45.79-1.02.79h-16.69c-.56 0-1.02-.35-1.02-.79 0-.43.46-.78 1.02-.78z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M167.33 232.37h16.7c.56 0 1.03.3 1.03.66 0 .37-.47.67-1.03.67h-16.7c-.56 0-1.02-.3-1.02-.67 0-.36.46-.66 1.02-.66"
				fill="#c8b100"
			/>
			<path
				d="M167.33 232.37h16.7c.56 0 1.03.3 1.03.66 0 .37-.47.67-1.03.67h-16.7c-.56 0-1.02-.3-1.02-.67 0-.36.46-.66 1.02-.66z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M191.28 330.68a8.48 8.48 0 01-3.93-.87 8.7 8.7 0 00-3.86-.82c-1.5 0-2.9.32-3.9.83-1.02.53-2.41.86-3.93.86a8.48 8.48 0 01-3.93-.9c-1-.5-2.33-.8-3.8-.8a8.5 8.5 0 00-3.85.82 8.64 8.64 0 01-3.95.88v2.41c1.53 0 2.94-.35 3.95-.88 1-.52 2.34-.82 3.86-.82 1.45 0 2.79.3 3.79.8 1 .54 2.39.9 3.93.9 1.52 0 2.91-.33 3.92-.86 1-.52 2.4-.84 3.9-.84s2.87.32 3.87.84a8.4 8.4 0 003.91.86l.02-2.41"
				fill="#005bbf"
			/>
			<path
				d="M191.28 330.68a8.48 8.48 0 01-3.93-.87 8.7 8.7 0 00-3.86-.82c-1.5 0-2.9.32-3.9.83-1.02.53-2.41.86-3.93.86a8.48 8.48 0 01-3.93-.9c-1-.5-2.33-.8-3.8-.8a8.5 8.5 0 00-3.85.82 8.64 8.64 0 01-3.95.88v2.41c1.53 0 2.94-.35 3.95-.88 1-.52 2.34-.82 3.86-.82 1.45 0 2.79.3 3.79.8 1 .54 2.39.9 3.93.9 1.52 0 2.91-.33 3.92-.86 1-.52 2.4-.84 3.9-.84s2.87.32 3.87.84a8.4 8.4 0 003.91.86l.02-2.41z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M191.28 333.09a8.5 8.5 0 01-3.93-.86c-1-.52-2.36-.84-3.86-.84s-2.9.32-3.9.84c-1.02.53-2.41.86-3.93.86a8.52 8.52 0 01-3.93-.9c-1-.5-2.33-.8-3.8-.8-1.5 0-2.85.3-3.85.82a8.69 8.69 0 01-3.95.88v2.4a8.7 8.7 0 003.95-.87c1-.52 2.34-.82 3.86-.82 1.45 0 2.79.3 3.79.8 1 .54 2.39.9 3.93.9a8.7 8.7 0 003.92-.86c1-.52 2.4-.84 3.9-.84s2.87.32 3.87.83c1.02.54 2.37.87 3.91.87l.02-2.41"
				fill="#ccc"
			/>
			<path
				d="M191.28 333.09a8.5 8.5 0 01-3.93-.86c-1-.52-2.36-.84-3.86-.84s-2.9.32-3.9.84c-1.02.53-2.41.86-3.93.86a8.52 8.52 0 01-3.93-.9c-1-.5-2.33-.8-3.8-.8-1.5 0-2.85.3-3.85.82a8.69 8.69 0 01-3.95.88v2.4a8.7 8.7 0 003.95-.87c1-.52 2.34-.82 3.86-.82 1.45 0 2.79.3 3.79.8 1 .54 2.39.9 3.93.9a8.7 8.7 0 003.92-.86c1-.52 2.4-.84 3.9-.84s2.87.32 3.87.83c1.02.54 2.37.87 3.91.87l.02-2.41"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M191.28 335.5a8.52 8.52 0 01-3.93-.87c-1-.5-2.36-.83-3.86-.83s-2.9.32-3.9.84c-1.02.53-2.41.86-3.93.86a8.52 8.52 0 01-3.93-.9c-1-.5-2.33-.8-3.8-.8-1.5 0-2.85.3-3.85.82a8.7 8.7 0 01-3.95.88v2.4c1.53 0 2.94-.34 3.95-.88 1-.51 2.34-.8 3.86-.8 1.45 0 2.79.3 3.79.79 1 .54 2.39.9 3.93.9 1.52 0 2.91-.33 3.92-.86 1-.52 2.4-.83 3.9-.83s2.87.3 3.87.82c1.02.55 2.37.86 3.91.86l.02-2.4"
				fill="#005bbf"
			/>
			<path
				d="M191.28 335.5a8.52 8.52 0 01-3.93-.87c-1-.5-2.36-.83-3.86-.83s-2.9.32-3.9.84c-1.02.53-2.41.86-3.93.86a8.52 8.52 0 01-3.93-.9c-1-.5-2.33-.8-3.8-.8-1.5 0-2.85.3-3.85.82a8.7 8.7 0 01-3.95.88v2.4c1.53 0 2.94-.34 3.95-.88 1-.51 2.34-.8 3.86-.8 1.45 0 2.79.3 3.79.79 1 .54 2.39.9 3.93.9 1.52 0 2.91-.33 3.92-.86 1-.52 2.4-.83 3.9-.83s2.87.3 3.87.82c1.02.55 2.37.86 3.91.86l.02-2.4"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M191.26 340.32c-1.54 0-2.9-.33-3.9-.87a8.7 8.7 0 00-3.87-.82c-1.5 0-2.9.31-3.9.83-1.02.52-2.41.86-3.93.86a8.48 8.48 0 01-3.93-.9c-1-.5-2.33-.8-3.8-.8-1.5 0-2.85.3-3.85.82a8.64 8.64 0 01-3.95.88v-2.4c1.53 0 2.94-.36 3.95-.9 1-.51 2.34-.8 3.86-.8 1.45 0 2.79.3 3.79.79 1 .54 2.39.9 3.93.9 1.52 0 2.91-.33 3.92-.86 1-.52 2.4-.83 3.9-.83s2.87.3 3.87.82c1.02.55 2.39.86 3.93.86l-.02 2.42"
				fill="#ccc"
			/>
			<path
				d="M191.26 340.32c-1.54 0-2.9-.33-3.9-.87a8.7 8.7 0 00-3.87-.82c-1.5 0-2.9.31-3.9.83-1.02.52-2.41.86-3.93.86a8.48 8.48 0 01-3.93-.9c-1-.5-2.33-.8-3.8-.8-1.5 0-2.85.3-3.85.82a8.64 8.64 0 01-3.95.88v-2.4c1.53 0 2.94-.36 3.95-.9 1-.51 2.34-.8 3.86-.8 1.45 0 2.79.3 3.79.79 1 .54 2.39.9 3.93.9 1.52 0 2.91-.33 3.92-.86 1-.52 2.4-.83 3.9-.83s2.87.3 3.87.82c1.02.55 2.39.86 3.93.86l-.02 2.42"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M191.26 342.73c-1.54 0-2.9-.33-3.9-.86a8.6 8.6 0 00-3.87-.84c-1.5 0-2.9.32-3.9.84-1.02.52-2.41.86-3.93.86a8.52 8.52 0 01-3.93-.9c-1-.5-2.33-.8-3.8-.8a8.5 8.5 0 00-3.85.82 8.69 8.69 0 01-3.95.88v-2.4c1.53 0 2.94-.36 3.95-.9 1-.51 2.34-.8 3.86-.8 1.45 0 2.79.3 3.79.79 1 .53 2.39.9 3.93.9a8.7 8.7 0 003.92-.86c1-.52 2.4-.83 3.9-.83s2.87.31 3.87.82a8.5 8.5 0 003.93.87l-.02 2.4"
				fill="#005bbf"
			/>
			<path
				d="M191.26 342.73c-1.54 0-2.9-.33-3.9-.86a8.6 8.6 0 00-3.87-.84c-1.5 0-2.9.32-3.9.84-1.02.52-2.41.86-3.93.86a8.52 8.52 0 01-3.93-.9c-1-.5-2.33-.8-3.8-.8a8.5 8.5 0 00-3.85.82 8.69 8.69 0 01-3.95.88v-2.4c1.53 0 2.94-.36 3.95-.9 1-.51 2.34-.8 3.86-.8 1.45 0 2.79.3 3.79.79 1 .53 2.39.9 3.93.9a8.7 8.7 0 003.92-.86c1-.52 2.4-.83 3.9-.83s2.87.31 3.87.82a8.5 8.5 0 003.93.87l-.02 2.4z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M166.92 320.78c.05.2.13.4.13.62 0 1.46-1.27 2.63-2.81 2.63h22.94c-1.55 0-2.81-1.17-2.81-2.63 0-.21.04-.41.1-.62-.14.05-.3.06-.45.06h-16.69c-.13 0-.29-.02-.41-.06"
				fill="#c8b100"
			/>
			<path
				d="M166.92 320.78c.05.2.13.4.13.62 0 1.46-1.27 2.63-2.81 2.63h22.94c-1.55 0-2.81-1.17-2.81-2.63 0-.21.04-.41.1-.62-.14.05-.3.06-.45.06h-16.69c-.13 0-.29-.02-.41-.06z"
				fill="none"
				stroke="#000"
				strokeLinejoin="round"
				strokeWidth={0.39}
			/>
			<path
				d="M167.33 319.27h16.7c.56 0 1.01.35 1.01.78 0 .44-.45.79-1.02.79h-16.69c-.56 0-1.02-.35-1.02-.79 0-.43.46-.78 1.02-.78"
				fill="#c8b100"
			/>
			<path
				d="M167.33 319.27h16.7c.56 0 1.01.35 1.01.78 0 .44-.45.79-1.02.79h-16.69c-.56 0-1.02-.35-1.02-.79 0-.43.46-.78 1.02-.78z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path d="M164.27 329.86h22.88v-5.83h-22.88v5.83z" fill="#c8b100" />
			<path
				d="M164.27 329.86h22.88v-5.83h-22.88v5.83z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M162.48 298.62c-2.26 1.3-3.8 2.64-3.55 3.31.12.62.84 1.07 1.87 1.75 1.62 1.13 2.6 3.14 1.83 4.07a5.76 5.76 0 00-.15-9.13"
				fill="#ad1519"
			/>
			<path
				d="M162.48 298.62c-2.26 1.3-3.8 2.64-3.55 3.31.12.62.84 1.07 1.87 1.75 1.62 1.13 2.6 3.14 1.83 4.07a5.76 5.76 0 00-.15-9.13z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path d="M167.55 318.32h16.25V238.7h-16.25v79.63z" fill="#ccc" />
			<path
				d="M179.13 238.8v79.46m1.83-79.46v79.46m-13.41.06h16.25V238.7h-16.25v79.63z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M200.4 268.47c-3.54-1.46-9.57-2.55-16.5-2.78a50.2 50.2 0 00-7.78.7c-9.72 1.63-17.13 5.5-16.54 8.67l.05.26s-3.64-8.2-3.7-8.52c-.65-3.51 7.56-7.82 18.35-9.62 3.39-.57 6.7-.79 9.56-.76 6.9 0 12.9.89 16.52 2.23l.04 9.82"
				fill="#ad1519"
			/>
			<path
				d="M200.4 268.47c-3.54-1.46-9.57-2.55-16.5-2.78a50.2 50.2 0 00-7.78.7c-9.72 1.63-17.13 5.5-16.54 8.67l.05.26s-3.64-8.2-3.7-8.52c-.65-3.51 7.56-7.82 18.35-9.62 3.39-.57 6.7-.79 9.56-.76 6.9 0 12.9.89 16.52 2.23l.04 9.82"
				fill="none"
				stroke="#000"
				strokeLinejoin="round"
				strokeWidth={0.39}
			/>
			<path
				d="M167.52 278.47c-4.5-.32-7.59-1.53-7.94-3.41-.28-1.5 1.25-3.17 3.97-4.68 1.21.14 2.58.3 4 .3l-.03 7.79"
				fill="#ad1519"
			/>
			<path
				d="M167.52 278.47c-4.5-.32-7.59-1.53-7.94-3.41-.28-1.5 1.25-3.17 3.97-4.68 1.21.14 2.58.3 4 .3l-.03 7.79"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M183.83 272.38c2.82.43 4.93 1.13 5.98 1.99l.1.17c.5 1.03-1.97 3.22-6.1 5.67l.02-7.83"
				fill="#ad1519"
			/>
			<path
				d="M183.83 272.38c2.82.43 4.93 1.13 5.98 1.99l.1.17c.5 1.03-1.97 3.22-6.1 5.67l.02-7.83"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M157.42 293.83c-.43-1.28 3.97-3.86 10.18-6.14 2.84-1.01 5.18-2.07 8.09-3.35 8.63-3.82 15-8.2 14.22-9.8l-.09-.16c.46.38 1.18 8.24 1.18 8.24.78 1.46-5.05 5.78-13 9.58-2.54 1.22-7.9 3.2-10.44 4.1-4.54 1.56-9.04 4.53-8.63 5.63l-1.5-8.1"
				fill="#ad1519"
			/>
			<path
				d="M157.42 293.83c-.43-1.28 3.97-3.86 10.18-6.14 2.84-1.01 5.18-2.07 8.09-3.35 8.63-3.82 15-8.2 14.22-9.8l-.09-.16c.46.38 1.18 8.24 1.18 8.24.78 1.46-5.05 5.78-13 9.58-2.54 1.22-7.9 3.2-10.44 4.1-4.54 1.56-9.04 4.53-8.63 5.63l-1.5-8.1z"
				fill="none"
				stroke="#000"
				strokeLinejoin="round"
				strokeWidth={0.39}
			/>
			<path
				d="M166.43 264.65c1.98-.72 3.28-1.58 2.65-3.14-.4-1-1.43-1.19-2.97-.63l-2.72.99 2.45 6.03c.27-.12.54-.24.81-.34.28-.1.57-.18.85-.26l-1.07-2.64zm-1.19-2.9l.69-.26c.57-.2 1.22.1 1.5.8.21.53.16 1.13-.5 1.55-.21.13-.46.23-.7.33l-.99-2.43m7.54-2.52c-.29.07-.57.16-.86.22l-.88.13 1.41 6.27 4.38-.88c-.05-.13-.12-.26-.14-.38-.03-.14-.03-.28-.04-.41-.77.22-1.6.46-2.61.66l-1.26-5.61m8.78 5.41c.82-2.28 1.82-4.46 2.81-6.67a5.51 5.51 0 01-1.08.07c-.53 1.6-1.18 3.2-1.87 4.8-.82-1.51-1.73-2.99-2.43-4.51-.34.04-.69.1-1.03.12-.34.02-.7.01-1.04.02 1.26 2.06 2.48 4.1 3.64 6.23l.5-.08c.16 0 .33 0 .5.02m9.16-4.83c.15-.3.3-.6.48-.89a3.6 3.6 0 00-1.81-.63c-1.79-.18-2.81.61-2.93 1.7-.26 2.25 3.3 2.06 3.14 3.56-.07.64-.75.9-1.48.83-.81-.08-1.4-.53-1.51-1.19l-.22-.02c-.12.4-.3.77-.48 1.15.53.34 1.2.53 1.85.6 1.83.18 3.22-.55 3.35-1.75.23-2.15-3.37-2.27-3.23-3.54.06-.53.47-.88 1.4-.79.67.07 1.08.43 1.26.95l.18.02"
				fill="#c8b100"
			/>
			<path
				d="M324.85 220.42s-.74.78-1.28.89c-.53.1-1.21-.49-1.21-.49s-.48.5-1.08.64c-.59.14-1.41-.67-1.41-.67s-.57.8-1.07 1c-.51.18-1.13-.24-1.13-.24s-.23.4-.65.61c-.18.09-.48-.05-.48-.05l-.6-.38-.68-.72-.62-.24s-.28-.91-.3-1.07l-.1-.57c-.12-.64.88-1.4 2.31-1.72.82-.2 1.54-.18 2.06-.02.57-.48 1.78-.82 3.2-.82 1.29 0 2.42.27 3.04.7.61-.43 1.74-.7 3.03-.7 1.42 0 2.62.34 3.2.82a4.1 4.1 0 012.06.02c1.42.32 2.43 1.08 2.3 1.72l-.08.57c-.03.16-.31 1.07-.31 1.07l-.63.24-.68.72-.59.38s-.3.14-.47.05a1.76 1.76 0 01-.66-.61s-.62.42-1.13.24c-.5-.2-1.07-1-1.07-1s-.82.8-1.42.67c-.59-.13-1.07-.64-1.07-.64s-.68.6-1.21.49c-.54-.11-1.27-.89-1.27-.89"
				fill="#ad1519"
			/>
			<path
				d="M324.85 220.42s-.74.78-1.28.89c-.53.1-1.21-.49-1.21-.49s-.48.5-1.08.64c-.59.14-1.41-.67-1.41-.67s-.57.8-1.07 1c-.51.18-1.13-.24-1.13-.24s-.23.4-.65.61c-.18.09-.48-.05-.48-.05l-.6-.38-.68-.72-.62-.24s-.28-.91-.3-1.07l-.1-.57c-.12-.64.88-1.4 2.31-1.72.82-.2 1.54-.18 2.06-.02.57-.48 1.78-.82 3.2-.82 1.29 0 2.42.27 3.04.7.61-.43 1.74-.7 3.03-.7 1.42 0 2.62.34 3.2.82a4.1 4.1 0 012.06.02c1.42.32 2.43 1.08 2.3 1.72l-.08.57c-.03.16-.31 1.07-.31 1.07l-.63.24-.68.72-.59.38s-.3.14-.47.05a1.76 1.76 0 01-.66-.61s-.62.42-1.13.24c-.5-.2-1.07-1-1.07-1s-.82.8-1.42.67c-.59-.13-1.07-.64-1.07-.64s-.68.6-1.21.49c-.54-.11-1.27-.89-1.27-.89z"
				fill="none"
				stroke="#000"
				strokeWidth={0.27}
			/>
			<path
				d="M323.45 216.2c0-1.09.61-1.96 1.37-1.96.76 0 1.38.87 1.38 1.96 0 1.08-.62 1.96-1.38 1.96-.76 0-1.37-.88-1.37-1.96"
				fill="#c8b100"
			/>
			<path
				d="M323.45 216.2c0-1.09.61-1.96 1.37-1.96.76 0 1.38.87 1.38 1.96 0 1.08-.62 1.96-1.38 1.96-.76 0-1.37-.88-1.37-1.96z"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M324.22 216.2c0-1 .28-1.8.63-1.8s.63.8.63 1.8-.28 1.8-.63 1.8-.63-.8-.63-1.8"
				fill="#c8b100"
			/>
			<path
				d="M324.22 216.2c0-1 .28-1.8.63-1.8s.63.8.63 1.8-.28 1.8-.63 1.8-.63-.8-.63-1.8z"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M317.75 224.25a4.72 4.72 0 00-.58-1.08c1.94-.57 4.65-.93 7.67-.94 3.01 0 5.74.37 7.69.94l-.52.91c-.17.3-.4.81-.38.81a23.8 23.8 0 00-6.8-.82c-2.79 0-5.47.35-6.86.86.02 0-.1-.32-.24-.68h.02"
				fill="#c8b100"
			/>
			<path
				d="M317.75 224.25a4.72 4.72 0 00-.58-1.08c1.94-.57 4.65-.93 7.67-.94 3.01 0 5.74.37 7.69.94l-.52.91c-.17.3-.4.81-.38.81a23.8 23.8 0 00-6.8-.82c-2.79 0-5.47.35-6.86.86.02 0-.1-.32-.24-.68h.02"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M324.84 226.73c2.43 0 5.1-.38 6.1-.63.66-.2 1.05-.5.97-.84-.03-.16-.17-.3-.37-.38-1.45-.47-4.06-.8-6.7-.8-2.64 0-5.27.33-6.72.8-.19.08-.33.22-.37.38-.07.35.32.65.98.84.99.25 3.68.62 6.1.63"
				fill="#c8b100"
			/>
			<path
				d="M324.84 226.73c2.43 0 5.1-.38 6.1-.63.66-.2 1.05-.5.97-.84-.03-.16-.17-.3-.37-.38-1.45-.47-4.06-.8-6.7-.8-2.64 0-5.27.33-6.72.8-.19.08-.33.22-.37.38-.07.35.32.65.98.84.99.25 3.68.62 6.1.63z"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M330.74 217.07c0-.23.2-.42.44-.42.26 0 .46.19.46.42 0 .24-.2.43-.45.43a.44.44 0 01-.45-.43"
				fill="#fff"
			/>
			<path
				d="M330.74 217.07c0-.23.2-.42.44-.42.26 0 .46.19.46.42 0 .24-.2.43-.45.43a.44.44 0 01-.45-.43zm-.26-1.49c0-.24.2-.43.45-.43s.45.19.45.43c0 .23-.2.42-.45.42a.44.44 0 01-.45-.42zm-1.13-.94c0-.24.2-.43.45-.43s.45.2.45.43c0 .24-.2.43-.45.43a.44.44 0 01-.45-.43zm-1.42-.45c0-.24.2-.44.46-.44.25 0 .45.2.45.44 0 .23-.2.42-.45.42s-.46-.2-.46-.42zm-1.44.05c0-.24.2-.43.45-.43.26 0 .46.19.46.43 0 .23-.2.42-.45.42a.44.44 0 01-.45-.42z"
				fill="none"
				stroke="#000"
				strokeWidth={0.21}
			/>
			<path
				d="M335.2 219.99a2.85 2.85 0 00-2.6-3.96c-.5 0-.97.13-1.38.37"
				fill="none"
				stroke="#000"
				strokeLinecap="round"
				strokeWidth={0.26}
			/>
			<path
				d="M330.17 217.96c.15-.26.25-.57.25-.87 0-1.15-1.18-2.08-2.64-2.08-.62 0-1.2.17-1.64.45"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M335.6 218.68c0-.24.2-.43.45-.43s.45.2.45.43c0 .24-.2.43-.45.43s-.45-.2-.45-.43zm-.18-1.58c0-.24.21-.42.46-.42s.45.18.45.42-.2.43-.45.43-.45-.2-.45-.43zm-1-1.2c0-.24.2-.43.44-.43.25 0 .45.2.45.43 0 .23-.2.42-.45.42a.44.44 0 01-.45-.42zm-1.37-.65c0-.23.2-.42.46-.42.25 0 .45.19.45.42 0 .24-.2.44-.45.44a.44.44 0 01-.46-.44zm-1.44.06c0-.24.2-.43.45-.43s.46.2.46.43c0 .23-.2.43-.46.43-.25 0-.45-.2-.45-.43z"
				fill="none"
				stroke="#000"
				strokeWidth={0.21}
			/>
			<path
				d="M332.65 222.08l-.6-.53s-.56.34-1.27.24c-.7-.11-.93-.97-.93-.97s-.8.67-1.44.62a1.7 1.7 0 01-1.07-.62s-.71.5-1.33.46c-.62-.06-1.22-.83-1.22-.83s-.62.8-1.24.86c-.62.05-1.13-.54-1.13-.54s-.29.59-1.08.72-1.47-.62-1.47-.62-.44.73-.98.92c-.54.18-1.24-.27-1.24-.27l-.2.43c-.09.16-.31.19-.31.19l.17.47c1.94-.56 4.57-.9 7.54-.9 2.97 0 5.67.34 7.6.9l.2-.53"
				fill="#c8b100"
			/>
			<path
				d="M332.65 222.08l-.6-.53s-.56.34-1.27.24c-.7-.11-.93-.97-.93-.97s-.8.67-1.44.62a1.7 1.7 0 01-1.07-.62s-.71.5-1.33.46c-.62-.06-1.22-.83-1.22-.83s-.62.8-1.24.86c-.62.05-1.13-.54-1.13-.54s-.29.59-1.08.72-1.47-.62-1.47-.62-.44.73-.98.92c-.54.18-1.24-.27-1.24-.27l-.2.43c-.09.16-.31.19-.31.19l.17.47c1.94-.56 4.57-.9 7.54-.9 2.97 0 5.67.34 7.6.9l.2-.53z"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M317.98 217.07c0-.23.2-.42.45-.42s.45.19.45.42c0 .24-.2.43-.45.43s-.45-.19-.45-.43"
				fill="#fff"
			/>
			<path
				d="M317.98 217.07c0-.23.2-.42.45-.42s.45.19.45.42c0 .24-.2.43-.45.43s-.45-.19-.45-.43zm.25-1.49c0-.24.2-.43.45-.43s.45.19.45.43c0 .23-.2.42-.44.42-.26 0-.46-.19-.46-.42zm1.13-.94c0-.24.2-.43.45-.43s.46.2.46.43c0 .24-.2.43-.46.43a.44.44 0 01-.45-.43zm1.41-.45c0-.24.2-.44.46-.44.25 0 .45.2.45.44 0 .23-.2.42-.45.42s-.46-.2-.46-.42zm1.45.05c0-.24.2-.43.45-.43s.45.19.45.43c0 .23-.2.42-.45.42a.44.44 0 01-.45-.42z"
				fill="none"
				stroke="#000"
				strokeWidth={0.21}
			/>
			<path
				d="M314.4 219.99a2.85 2.85 0 012.6-3.96c.51 0 .98.13 1.4.37"
				fill="none"
				stroke="#000"
				strokeLinecap="round"
				strokeWidth={0.26}
			/>
			<path
				d="M319.48 217.93a1.75 1.75 0 01-.29-.84c0-1.15 1.19-2.08 2.64-2.08.62 0 1.2.17 1.65.45"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M313.11 218.68c0-.24.2-.43.46-.43.24 0 .45.2.45.43 0 .24-.2.43-.45.43s-.46-.2-.46-.43zm.17-1.58c0-.24.2-.42.46-.42.25 0 .45.18.45.42s-.2.43-.45.43-.46-.2-.46-.43zm1.02-1.2c0-.24.2-.43.46-.43.24 0 .45.2.45.43 0 .23-.2.42-.45.42a.44.44 0 01-.46-.42zm1.36-.65c0-.23.2-.42.45-.42s.45.19.45.42c0 .24-.2.44-.45.44a.44.44 0 01-.45-.44zm1.44.06c0-.24.2-.43.45-.43s.45.2.45.43c0 .23-.2.43-.45.43s-.45-.2-.45-.43z"
				fill="none"
				stroke="#000"
				strokeWidth={0.21}
			/>
			<path
				d="M324.85 219.5l.28.04c-.04.12-.05.24-.05.38 0 .58.5 1.05 1.12 1.05.5 0 .91-.3 1.05-.73.02.01.11-.38.16-.38.04 0 .03.41.04.4.07.53.56.9 1.1.9.62 0 1.12-.47 1.12-1.06l-.01-.12.35-.35.19.44c-.08.14-.1.3-.1.46 0 .56.47 1 1.06 1 .37 0 .7-.17.88-.44l.23-.29v.35c0 .35.14.66.48.72 0 0 .4.03.91-.38.53-.41.81-.75.81-.75l.03.42s-.51.84-.97 1.1c-.25.15-.64.3-.95.25-.33-.04-.55-.3-.68-.6-.23.13-.5.21-.8.21-.62 0-1.19-.35-1.41-.86a1.63 1.63 0 01-2.42-.08 1.63 1.63 0 01-2.43-.26 1.62 1.62 0 01-2.42.26c-.3.35-.75.58-1.26.58-.47 0-.87-.19-1.16-.5-.22.5-.79.86-1.42.86-.29 0-.56-.08-.8-.22-.11.3-.34.56-.67.61-.3.06-.69-.1-.94-.25-.47-.26-1.02-1.1-1.02-1.1l.07-.42s.28.34.8.75.92.38.92.38c.34-.06.48-.37.48-.72v-.35l.23.29c.19.27.51.45.88.45.6 0 1.07-.45 1.07-1.01a.93.93 0 00-.1-.46l.18-.44.35.35-.01.12c0 .59.5 1.06 1.1 1.06.56 0 1.04-.37 1.11-.9.02.01.01-.4.05-.4.05 0 .14.4.15.38.15.42.57.73 1.06.73a1.09 1.09 0 001.07-1.43l.29-.05"
				fill="#c8b100"
			/>
			<path
				d="M324.85 219.5l.28.04c-.04.12-.05.24-.05.38 0 .58.5 1.05 1.12 1.05.5 0 .91-.3 1.05-.73.02.01.11-.38.16-.38.04 0 .03.41.04.4.07.53.56.9 1.1.9.62 0 1.12-.47 1.12-1.06l-.01-.12.35-.35.19.44c-.08.14-.1.3-.1.46 0 .56.47 1 1.06 1 .37 0 .7-.17.88-.44l.23-.29v.35c0 .35.14.66.48.72 0 0 .4.03.91-.38.53-.41.81-.75.81-.75l.03.42s-.51.84-.97 1.1c-.25.15-.64.3-.95.25-.33-.04-.55-.3-.68-.6-.23.13-.5.21-.8.21-.62 0-1.19-.35-1.41-.86a1.63 1.63 0 01-2.42-.08 1.63 1.63 0 01-2.43-.26 1.62 1.62 0 01-2.42.26c-.3.35-.75.58-1.26.58-.47 0-.87-.19-1.16-.5-.22.5-.79.86-1.42.86-.29 0-.56-.08-.8-.22-.11.3-.34.56-.67.61-.3.06-.69-.1-.94-.25-.47-.26-1.02-1.1-1.02-1.1l.07-.42s.28.34.8.75.92.38.92.38c.34-.06.48-.37.48-.72v-.35l.23.29c.19.27.51.45.88.45.6 0 1.07-.45 1.07-1.01a.93.93 0 00-.1-.46l.18-.44.35.35-.01.12c0 .59.5 1.06 1.1 1.06.56 0 1.04-.37 1.11-.9.02.01.01-.4.05-.4.05 0 .14.4.15.38.15.42.57.73 1.06.73a1.09 1.09 0 001.07-1.43l.29-.05z"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M324.84 222.23c-3.02 0-5.72.37-7.67.94-.13.04-.29-.06-.33-.17-.04-.13.05-.28.18-.32 1.95-.6 4.73-.97 7.82-.98 3.08 0 5.87.38 7.83.98.13.04.22.2.18.32-.04.11-.2.21-.33.17a28.45 28.45 0 00-7.68-.94"
				fill="#c8b100"
			/>
			<path
				d="M324.84 222.23c-3.02 0-5.72.37-7.67.94-.13.04-.29-.06-.33-.17-.04-.13.05-.28.18-.32 1.95-.6 4.73-.97 7.82-.98 3.08 0 5.87.38 7.83.98.13.04.22.2.18.32-.04.11-.2.21-.33.17a28.45 28.45 0 00-7.68-.94z"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M321.92 223.3c0-.22.2-.4.44-.4s.44.18.44.4c0 .23-.2.41-.44.41s-.44-.18-.44-.4"
				fill="#fff"
			/>
			<path
				d="M321.92 223.3c0-.22.2-.4.44-.4s.44.18.44.4c0 .23-.2.41-.44.41s-.44-.18-.44-.4z"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M324.88 223.48h-.98c-.18 0-.33-.14-.33-.31 0-.17.15-.3.33-.3h1.96c.18 0 .32.13.32.3 0 .17-.14.31-.32.31h-.99"
				fill="#ad1519"
			/>
			<path
				d="M324.88 223.48h-.98c-.18 0-.33-.14-.33-.31 0-.17.15-.3.33-.3h1.96c.18 0 .32.13.32.3 0 .17-.14.31-.32.31h-.99"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M320.02 223.81l-.7.1a.33.33 0 01-.37-.25.3.3 0 01.27-.35l.7-.1.7-.11c.18-.02.35.09.38.25.02.17-.1.33-.27.35l-.71.11"
				fill="#058e6e"
			/>
			<path
				d="M320.02 223.81l-.7.1a.33.33 0 01-.37-.25.3.3 0 01.27-.35l.7-.1.7-.11c.18-.02.35.09.38.25.02.17-.1.33-.27.35l-.71.11"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path d="M317.21 224.3l.31-.5.66.13-.38.56-.59-.19" fill="#ad1519" />
			<path
				d="M317.21 224.3l.31-.5.66.13-.38.56-.59-.19"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M326.89 223.3c0-.22.2-.4.43-.4.25 0 .44.18.44.4 0 .23-.2.41-.44.41s-.43-.18-.43-.4"
				fill="#fff"
			/>
			<path
				d="M326.89 223.3c0-.22.2-.4.43-.4.25 0 .44.18.44.4 0 .23-.2.41-.44.41s-.43-.18-.43-.4z"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M329.66 223.81l.7.1c.18.03.34-.08.37-.25a.3.3 0 00-.26-.35l-.7-.1-.71-.11c-.18-.02-.35.09-.38.25-.03.17.1.33.28.35l.7.11"
				fill="#058e6e"
			/>
			<path
				d="M329.66 223.81l.7.1c.18.03.34-.08.37-.25a.3.3 0 00-.26-.35l-.7-.1-.71-.11c-.18-.02-.35.09-.38.25-.03.17.1.33.28.35l.7.11"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path d="M332.4 224.33l-.24-.53-.68.06.33.59.6-.12" fill="#ad1519" />
			<path
				d="M332.4 224.33l-.24-.53-.68.06.33.59.6-.12"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M324.83 226.16c-2.43 0-4.63-.22-6.3-.65 1.67-.43 3.87-.7 6.3-.7 2.44 0 4.65.27 6.32.7-1.67.44-3.88.65-6.32.65"
				fill="#ad1519"
			/>
			<path
				d="M324.83 226.16c-2.43 0-4.63-.22-6.3-.65 1.67-.43 3.87-.7 6.3-.7 2.44 0 4.65.27 6.32.7-1.67.44-3.88.65-6.32.65z"
				fill="none"
				stroke="#000"
				strokeLinejoin="round"
				strokeWidth={0.26}
			/>
			<path
				d="M332.5 220.88c.07-.18.01-.37-.13-.41-.13-.04-.3.08-.36.26-.06.19 0 .38.13.42.14.04.3-.08.37-.27"
				fill="#c8b100"
			/>
			<path
				d="M332.5 220.88c.07-.18.01-.37-.13-.41-.13-.04-.3.08-.36.26-.06.19 0 .38.13.42.14.04.3-.08.37-.27z"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M327.66 219.95c.03-.2-.07-.37-.21-.39-.14-.02-.28.13-.3.33-.03.2.06.37.2.38.15.02.28-.13.31-.32"
				fill="#c8b100"
			/>
			<path
				d="M327.66 219.95c.03-.2-.07-.37-.21-.39-.14-.02-.28.13-.3.33-.03.2.06.37.2.38.15.02.28-.13.31-.32z"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M322.04 219.95c-.03-.2.06-.37.2-.39.15-.02.28.13.31.33.02.2-.07.37-.2.38-.15.02-.29-.13-.31-.32"
				fill="#c8b100"
			/>
			<path
				d="M322.04 219.95c-.03-.2.06-.37.2-.39.15-.02.28.13.31.33.02.2-.07.37-.2.38-.15.02-.29-.13-.31-.32z"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M317.2 220.88c-.07-.18-.01-.37.12-.41.13-.04.3.08.36.26.07.19.01.38-.12.42-.14.04-.3-.08-.37-.27"
				fill="#c8b100"
			/>
			<path
				d="M317.2 220.88c-.07-.18-.01-.37.12-.41.13-.04.3.08.36.26.07.19.01.38-.12.42-.14.04-.3-.08-.37-.27z"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M324.83 217.15l-.85.52.63 1.38.22.14.22-.14.64-1.38-.86-.52"
				fill="#c8b100"
			/>
			<path
				d="M324.83 217.15l-.85.52.63 1.38.22.14.22-.14.64-1.38-.86-.52"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M322.95 219.24l.4.57 1.33-.42.14-.18-.14-.2-1.34-.39-.39.62"
				fill="#c8b100"
			/>
			<path
				d="M322.95 219.24l.4.57 1.33-.42.14-.18-.14-.2-1.34-.39-.39.62"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M326.72 219.24l-.39.57-1.34-.42-.14-.18.14-.2 1.34-.39.4.62"
				fill="#c8b100"
			/>
			<path
				d="M326.72 219.24l-.39.57-1.34-.42-.14-.18.14-.2 1.34-.39.4.62"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M319.25 217.76l-.67.64.86 1.14.23.09.17-.18.3-1.37-.89-.32"
				fill="#c8b100"
			/>
			<path
				d="M319.25 217.76l-.67.64.86 1.14.23.09.17-.18.3-1.37-.89-.32"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M317.84 220.04l.5.48 1.23-.66.09-.21-.18-.16-1.4-.13-.24.68"
				fill="#c8b100"
			/>
			<path
				d="M317.84 220.04l.5.48 1.23-.66.09-.21-.18-.16-1.4-.13-.24.68"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M321.53 219.3l-.26.63-1.4-.13-.18-.16.1-.21 1.22-.65.52.52"
				fill="#c8b100"
			/>
			<path
				d="M321.53 219.3l-.26.63-1.4-.13-.18-.16.1-.21 1.22-.65.52.52"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M316.5 220.22l-.12.66-1.4.15-.22-.12.06-.23 1.05-.87.62.41"
				fill="#c8b100"
			/>
			<path
				d="M316.5 220.22l-.12.66-1.4.15-.22-.12.06-.23 1.05-.87.62.41"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M319.19 219.65c0-.26.22-.47.49-.47s.49.21.49.47c0 .25-.22.46-.5.46a.48.48 0 01-.48-.46"
				fill="#c8b100"
			/>
			<path
				d="M319.19 219.65c0-.26.22-.47.49-.47s.49.21.49.47c0 .25-.22.46-.5.46a.48.48 0 01-.48-.46z"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M330.44 217.76l.67.64-.86 1.14-.23.09-.17-.18-.3-1.37.89-.32"
				fill="#c8b100"
			/>
			<path
				d="M330.44 217.76l.67.64-.86 1.14-.23.09-.17-.18-.3-1.37.89-.32"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M331.85 220.04l-.5.48-1.23-.66-.1-.21.18-.16 1.4-.13.25.68"
				fill="#c8b100"
			/>
			<path
				d="M331.85 220.04l-.5.48-1.23-.66-.1-.21.18-.16 1.4-.13.25.68"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M328.16 219.3l.26.63 1.4-.13.18-.16-.1-.21-1.22-.65-.52.52"
				fill="#c8b100"
			/>
			<path
				d="M328.16 219.3l.26.63 1.4-.13.18-.16-.1-.21-1.22-.65-.52.52"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path d="M333 220.22l.12.66 1.4.15.2-.12-.04-.23-1.05-.87-.62.41" fill="#c8b100" />
			<path
				d="M333 220.22l.12.66 1.4.15.2-.12-.04-.23-1.05-.87-.62.41"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M324.35 219.2c0-.25.22-.46.5-.46.26 0 .48.2.48.47 0 .25-.22.46-.49.46a.48.48 0 01-.49-.46"
				fill="#c8b100"
			/>
			<path
				d="M324.35 219.2c0-.25.22-.46.5-.46.26 0 .48.2.48.47 0 .25-.22.46-.49.46a.48.48 0 01-.49-.46z"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M329.52 219.65c0-.26.23-.47.5-.47s.5.21.5.47c0 .25-.23.46-.5.46a.48.48 0 01-.5-.46"
				fill="#c8b100"
			/>
			<path
				d="M329.52 219.65c0-.26.23-.47.5-.47s.5.21.5.47c0 .25-.23.46-.5.46a.48.48 0 01-.5-.46z"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M323.92 213.95a.9.9 0 01.92-.87c.51 0 .93.39.93.87 0 .49-.42.88-.93.88a.9.9 0 01-.92-.88"
				fill="#c8b100"
			/>
			<path
				d="M325.5 213.64v.58h-1.43v-.58h.47v-1.3h-.62v-.59h.62v-.57h.6v.57h.61v.59h-.6v1.3h.34"
				fill="#c8b100"
			/>
			<path
				d="M325.5 213.64v.58h-1.43v-.58h.47v-1.3h-.62v-.59h.62v-.57h.6v.57h.61v.59h-.6v1.3h.34z"
				fill="none"
				stroke="#000"
				strokeWidth={0.3}
			/>
			<path
				d="M326.13 213.64v.58h-2.53v-.58h.94v-1.3h-.62v-.59h.62v-.57h.6v.57h.62v.59h-.61v1.3h.98"
				fill="#c8b100"
			/>
			<path
				d="M325.1 213.12c.39.1.67.44.67.83a.9.9 0 01-.93.88.9.9 0 01-.92-.88c0-.4.29-.74.68-.84"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M314.6 221c-.01 0-.38-.49-.66-.73-.2-.18-.67-.33-.67-.33 0-.09.28-.28.58-.28.18 0 .35.07.45.2l.03-.2s.25.05.36.32c.11.29.04.72.04.72s-.05.2-.13.3"
				fill="#c8b100"
			/>
			<path
				d="M314.6 221c-.01 0-.38-.49-.66-.73-.2-.18-.67-.33-.67-.33 0-.09.28-.28.58-.28.18 0 .35.07.45.2l.03-.2s.25.05.36.32c.11.29.04.72.04.72s-.05.2-.13.3z"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M314.62 220.75c.11-.12.35-.1.53.06.18.15.23.38.11.5-.11.13-.35.1-.53-.06-.18-.15-.23-.38-.11-.5"
				fill="#c8b100"
			/>
			<path
				d="M314.62 220.75c.11-.12.35-.1.53.06.18.15.23.38.11.5-.11.13-.35.1-.53-.06-.18-.15-.23-.38-.11-.5z"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M334.9 221c.01 0 .38-.49.65-.73.2-.18.68-.33.68-.33 0-.09-.28-.28-.59-.28a.58.58 0 00-.44.2l-.04-.2s-.25.05-.36.32c-.1.29-.04.72-.04.72s.05.2.14.3"
				fill="#c8b100"
			/>
			<path
				d="M334.9 221c.01 0 .38-.49.65-.73.2-.18.68-.33.68-.33 0-.09-.28-.28-.59-.28a.58.58 0 00-.44.2l-.04-.2s-.25.05-.36.32c-.1.29-.04.72-.04.72s.05.2.14.3z"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M334.91 220.75c-.12-.12-.36-.1-.54.06-.18.15-.23.38-.11.5.11.13.35.1.53-.06.18-.15.24-.38.12-.5"
				fill="#c8b100"
			/>
			<path
				d="M334.91 220.75c-.12-.12-.36-.1-.54.06-.18.15-.23.38-.11.5.11.13.35.1.53-.06.18-.15.24-.38.12-.5z"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path d="M313.71 232.37H336v-5.84h-22.3v5.84z" fill="#c8b100" />
			<path
				d="M313.71 232.37H336v-5.84h-22.3v5.84z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M333.66 236.26a.98.98 0 00-.41-.07h-16.7c-.16 0-.31.03-.45.08.57-.19.98-.7.98-1.32 0-.6-.44-1.14-1.02-1.33.14.04.32.08.49.08h16.7c.17 0 .32-.01.47-.06l-.1.02c-.6.18-.93.71-.93 1.3 0 .55.37 1.12.97 1.3"
				fill="#c8b100"
			/>
			<path
				d="M333.66 236.26a.98.98 0 00-.41-.07h-16.7c-.16 0-.31.03-.45.08.57-.19.98-.7.98-1.32 0-.6-.44-1.14-1.02-1.33.14.04.32.08.49.08h16.7c.17 0 .32-.01.47-.06l-.1.02c-.6.18-.93.71-.93 1.3 0 .55.37 1.12.97 1.3z"
				fill="none"
				stroke="#000"
				strokeLinejoin="round"
				strokeWidth={0.39}
			/>
			<path
				d="M316.56 236.2h16.69c.56 0 1.02.34 1.02.77 0 .44-.46.79-1.02.79h-16.7c-.56 0-1.01-.35-1.01-.79 0-.43.45-.78 1.02-.78"
				fill="#c8b100"
			/>
			<path
				d="M316.56 236.2h16.69c.56 0 1.02.34 1.02.77 0 .44-.46.79-1.02.79h-16.7c-.56 0-1.01-.35-1.01-.79 0-.43.45-.78 1.02-.78z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M316.55 232.37h16.7c.56 0 1.02.3 1.02.66 0 .37-.46.67-1.02.67h-16.7c-.57 0-1.03-.3-1.03-.67 0-.36.46-.66 1.03-.66"
				fill="#c8b100"
			/>
			<path
				d="M316.55 232.37h16.7c.56 0 1.02.3 1.02.66 0 .37-.46.67-1.02.67h-16.7c-.57 0-1.03-.3-1.03-.67 0-.36.46-.66 1.03-.66z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M309.3 330.68c1.54 0 2.91-.33 3.93-.87 1-.5 2.36-.82 3.86-.82s2.9.32 3.9.83c1.01.53 2.4.86 3.93.86a8.5 8.5 0 003.93-.9c1-.5 2.33-.8 3.8-.8a8.5 8.5 0 013.85.82c1.01.54 2.42.88 3.95.88v2.41a8.67 8.67 0 01-3.95-.88c-1-.52-2.34-.82-3.86-.82-1.46 0-2.8.3-3.79.8-1 .54-2.4.9-3.93.9a8.7 8.7 0 01-3.92-.86c-1-.52-2.4-.84-3.9-.84s-2.87.32-3.88.84a8.4 8.4 0 01-3.9.86l-.02-2.41"
				fill="#005bbf"
			/>
			<path
				d="M309.3 330.68c1.54 0 2.91-.33 3.93-.87 1-.5 2.36-.82 3.86-.82s2.9.32 3.9.83c1.01.53 2.4.86 3.93.86a8.5 8.5 0 003.93-.9c1-.5 2.33-.8 3.8-.8a8.5 8.5 0 013.85.82c1.01.54 2.42.88 3.95.88v2.41a8.67 8.67 0 01-3.95-.88c-1-.52-2.34-.82-3.86-.82-1.46 0-2.8.3-3.79.8-1 .54-2.4.9-3.93.9a8.7 8.7 0 01-3.92-.86c-1-.52-2.4-.84-3.9-.84s-2.87.32-3.88.84a8.4 8.4 0 01-3.9.86l-.02-2.41z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M309.3 333.09a8.5 8.5 0 003.93-.86c1-.52 2.36-.84 3.86-.84s2.9.32 3.9.84c1.01.53 2.4.86 3.93.86 1.54 0 2.92-.36 3.93-.9 1-.5 2.33-.8 3.8-.8 1.5 0 2.84.3 3.85.82 1.01.53 2.42.88 3.95.88v2.4a8.67 8.67 0 01-3.95-.87c-1-.52-2.34-.82-3.86-.82-1.46 0-2.8.3-3.79.8-1 .54-2.4.9-3.93.9a8.7 8.7 0 01-3.92-.86c-1-.52-2.4-.84-3.9-.84s-2.87.32-3.88.83a8.43 8.43 0 01-3.9.87l-.02-2.41"
				fill="#ccc"
			/>
			<path
				d="M309.3 333.09a8.5 8.5 0 003.93-.86c1-.52 2.36-.84 3.86-.84s2.9.32 3.9.84c1.01.53 2.4.86 3.93.86 1.54 0 2.92-.36 3.93-.9 1-.5 2.33-.8 3.8-.8 1.5 0 2.84.3 3.85.82 1.01.53 2.42.88 3.95.88v2.4a8.67 8.67 0 01-3.95-.87c-1-.52-2.34-.82-3.86-.82-1.46 0-2.8.3-3.79.8-1 .54-2.4.9-3.93.9a8.7 8.7 0 01-3.92-.86c-1-.52-2.4-.84-3.9-.84s-2.87.32-3.88.83a8.43 8.43 0 01-3.9.87l-.02-2.41"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M309.3 335.5c1.54 0 2.91-.33 3.93-.87 1-.5 2.36-.83 3.86-.83s2.9.32 3.9.84c1.01.53 2.4.86 3.93.86 1.54 0 2.92-.36 3.93-.9 1-.5 2.33-.8 3.8-.8 1.5 0 2.84.3 3.85.82 1.01.53 2.42.88 3.95.88v2.4a8.63 8.63 0 01-3.95-.88c-1-.51-2.34-.8-3.86-.8-1.46 0-2.8.3-3.79.79-1 .54-2.4.9-3.93.9a8.71 8.71 0 01-3.92-.86c-1-.52-2.4-.83-3.9-.83s-2.87.3-3.88.82a8.37 8.37 0 01-3.9.86l-.02-2.4"
				fill="#005bbf"
			/>
			<path
				d="M309.3 335.5c1.54 0 2.91-.33 3.93-.87 1-.5 2.36-.83 3.86-.83s2.9.32 3.9.84c1.01.53 2.4.86 3.93.86 1.54 0 2.92-.36 3.93-.9 1-.5 2.33-.8 3.8-.8 1.5 0 2.84.3 3.85.82 1.01.53 2.42.88 3.95.88v2.4a8.63 8.63 0 01-3.95-.88c-1-.51-2.34-.8-3.86-.8-1.46 0-2.8.3-3.79.79-1 .54-2.4.9-3.93.9a8.71 8.71 0 01-3.92-.86c-1-.52-2.4-.83-3.9-.83s-2.87.3-3.88.82a8.37 8.37 0 01-3.9.86l-.02-2.4"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M309.32 340.32a8.4 8.4 0 003.9-.87c1.01-.51 2.37-.82 3.87-.82s2.9.31 3.9.83c1.01.52 2.4.86 3.93.86a8.5 8.5 0 003.93-.9c1-.5 2.33-.8 3.8-.8 1.5 0 2.84.3 3.85.82 1.01.53 2.42.88 3.95.88v-2.4a8.63 8.63 0 01-3.95-.9c-1-.51-2.34-.8-3.86-.8-1.46 0-2.8.3-3.79.79-1 .54-2.4.9-3.93.9a8.71 8.71 0 01-3.92-.86c-1-.52-2.4-.83-3.9-.83s-2.87.3-3.88.82a8.46 8.46 0 01-3.92.86l.02 2.42"
				fill="#ccc"
			/>
			<path
				d="M309.32 340.32a8.4 8.4 0 003.9-.87c1.01-.51 2.37-.82 3.87-.82s2.9.31 3.9.83c1.01.52 2.4.86 3.93.86a8.5 8.5 0 003.93-.9c1-.5 2.33-.8 3.8-.8 1.5 0 2.84.3 3.85.82 1.01.53 2.42.88 3.95.88v-2.4a8.63 8.63 0 01-3.95-.9c-1-.51-2.34-.8-3.86-.8-1.46 0-2.8.3-3.79.79-1 .54-2.4.9-3.93.9a8.71 8.71 0 01-3.92-.86c-1-.52-2.4-.83-3.9-.83s-2.87.3-3.88.82a8.46 8.46 0 01-3.92.86l.02 2.42"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M309.32 342.73c1.54 0 2.9-.33 3.9-.86a8.6 8.6 0 013.87-.84c1.5 0 2.9.32 3.9.84 1.01.52 2.4.86 3.93.86 1.54 0 2.92-.37 3.93-.9 1-.5 2.33-.8 3.8-.8 1.5 0 2.84.3 3.85.82 1.01.53 2.42.88 3.95.88v-2.4a8.61 8.61 0 01-3.95-.9c-1-.51-2.34-.8-3.86-.8-1.46 0-2.8.3-3.79.79-1 .53-2.4.9-3.93.9a8.7 8.7 0 01-3.92-.86c-1-.52-2.4-.83-3.9-.83s-2.87.31-3.88.82a8.5 8.5 0 01-3.92.87l.02 2.4"
				fill="#005bbf"
			/>
			<path
				d="M309.32 342.73c1.54 0 2.9-.33 3.9-.86a8.6 8.6 0 013.87-.84c1.5 0 2.9.32 3.9.84 1.01.52 2.4.86 3.93.86 1.54 0 2.92-.37 3.93-.9 1-.5 2.33-.8 3.8-.8 1.5 0 2.84.3 3.85.82 1.01.53 2.42.88 3.95.88v-2.4a8.61 8.61 0 01-3.95-.9c-1-.51-2.34-.8-3.86-.8-1.46 0-2.8.3-3.79.79-1 .53-2.4.9-3.93.9a8.7 8.7 0 01-3.92-.86c-1-.52-2.4-.83-3.9-.83s-2.87.31-3.88.82a8.5 8.5 0 01-3.92.87l.02 2.4z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M333.66 320.78c-.06.2-.13.4-.13.62 0 1.46 1.27 2.63 2.8 2.63H313.4c1.55 0 2.8-1.17 2.8-2.63 0-.21-.03-.41-.08-.62.12.05.28.06.44.06h16.69c.13 0 .29-.02.4-.06"
				fill="#c8b100"
			/>
			<path
				d="M333.66 320.78c-.06.2-.13.4-.13.62 0 1.46 1.27 2.63 2.8 2.63H313.4c1.55 0 2.8-1.17 2.8-2.63 0-.21-.03-.41-.08-.62.12.05.28.06.44.06h16.69c.13 0 .29-.02.4-.06z"
				fill="none"
				stroke="#000"
				strokeLinejoin="round"
				strokeWidth={0.39}
			/>
			<path
				d="M316.56 319.27h16.69c.56 0 1.02.35 1.02.78 0 .44-.46.79-1.02.79h-16.7c-.56 0-1.01-.35-1.01-.79 0-.43.45-.78 1.02-.78"
				fill="#c8b100"
			/>
			<path
				d="M316.56 319.27h16.69c.56 0 1.02.35 1.02.78 0 .44-.46.79-1.02.79h-16.7c-.56 0-1.01-.35-1.01-.79 0-.43.45-.78 1.02-.78z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path d="M313.43 329.86h22.88v-5.83h-22.88v5.83z" fill="#c8b100" />
			<path
				d="M313.43 329.86h22.88v-5.83h-22.88v5.83z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M338.1 298.62c2.26 1.3 3.8 2.64 3.55 3.31-.12.62-.84 1.07-1.87 1.75-1.62 1.13-2.6 3.14-1.83 4.07a5.76 5.76 0 01.15-9.13"
				fill="#ad1519"
			/>
			<path
				d="M338.1 298.62c2.26 1.3 3.8 2.64 3.55 3.31-.12.62-.84 1.07-1.87 1.75-1.62 1.13-2.6 3.14-1.83 4.07a5.76 5.76 0 01.15-9.13z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path d="M316.78 318.32h16.25V238.7h-16.25v79.63z" fill="#ccc" />
			<path
				d="M328.57 238.66v79.46m1.82-79.46v79.46m-13.61.2h16.25V238.7h-16.25v79.63z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M300.17 268.47c3.55-1.46 9.58-2.55 16.5-2.78 2.38.02 5.04.25 7.79.7 9.72 1.63 17.12 5.5 16.54 8.67l-.05.26s3.64-8.2 3.7-8.52c.65-3.51-7.56-7.82-18.35-9.62a55.7 55.7 0 00-9.56-.76c-6.9 0-12.9.89-16.52 2.23l-.05 9.82"
				fill="#ad1519"
			/>
			<path
				d="M300.17 268.47c3.55-1.46 9.58-2.55 16.5-2.78 2.38.02 5.04.25 7.79.7 9.72 1.63 17.12 5.5 16.54 8.67l-.05.26s3.64-8.2 3.7-8.52c.65-3.51-7.56-7.82-18.35-9.62a55.7 55.7 0 00-9.56-.76c-6.9 0-12.9.89-16.52 2.23l-.05 9.82"
				fill="none"
				stroke="#000"
				strokeLinejoin="round"
				strokeWidth={0.39}
			/>
			<path
				d="M333.06 278.47c4.5-.32 7.59-1.53 7.94-3.41.28-1.5-1.25-3.17-3.97-4.68-1.22.14-2.59.3-4 .3l.03 7.79"
				fill="#ad1519"
			/>
			<path
				d="M333.06 278.47c4.5-.32 7.59-1.53 7.94-3.41.28-1.5-1.25-3.17-3.97-4.68-1.22.14-2.59.3-4 .3l.03 7.79"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M316.75 272.38c-2.82.43-4.93 1.13-5.99 1.99l-.1.17c-.5 1.03 1.98 3.22 6.11 5.67l-.02-7.83"
				fill="#ad1519"
			/>
			<path
				d="M316.75 272.38c-2.82.43-4.93 1.13-5.99 1.99l-.1.17c-.5 1.03 1.98 3.22 6.11 5.67l-.02-7.83"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M343.15 293.83c.43-1.28-3.96-3.86-10.17-6.14-2.84-1.01-5.19-2.07-8.1-3.35-8.62-3.82-15-8.2-14.2-9.8l.08-.16c-.46.38-1.17 8.24-1.17 8.24-.79 1.46 5.05 5.78 12.98 9.58 2.55 1.22 7.92 3.2 10.45 4.1 4.54 1.56 9.04 4.53 8.63 5.63l1.5-8.1"
				fill="#ad1519"
			/>
			<path
				d="M343.15 293.83c.43-1.28-3.96-3.86-10.17-6.14-2.84-1.01-5.19-2.07-8.1-3.35-8.62-3.82-15-8.2-14.2-9.8l.08-.16c-.46.38-1.17 8.24-1.17 8.24-.79 1.46 5.05 5.78 12.98 9.58 2.55 1.22 7.92 3.2 10.45 4.1 4.54 1.56 9.04 4.53 8.63 5.63l1.5-8.1z"
				fill="none"
				stroke="#000"
				strokeLinejoin="round"
				strokeWidth={0.39}
			/>
			<path
				d="M310.3 264.98c.62-2.33 1.41-4.58 2.2-6.87a5.52 5.52 0 01-1.08.16 54.67 54.67 0 01-1.42 4.94c-.95-1.44-2-2.84-2.83-4.3-.34.07-.68.15-1.02.2-.34.05-.7.07-1.04.1a143.9 143.9 0 014.2 5.92c.16-.04.32-.1.5-.12.16-.02.33-.02.5-.03m6.18-6.82l-.9.03c-.29 0-.59-.04-.88-.06l-.12 6.41 4.49.08c-.03-.13-.06-.27-.06-.41 0-.13.04-.27.07-.4-.8.05-1.68.1-2.71.08l.1-5.73m7.04 1.05c.72.06 1.41.19 2.1.31-.01-.13-.03-.27-.02-.4 0-.14.06-.27.1-.4l-6.07-.5c.01.13.03.27.02.4-.01.14-.06.27-.1.4a20.1 20.1 0 012.2.05l-.52 5.77c.3 0 .59 0 .88.03.3.02.6.07.88.11l.53-5.77m2.48 6.32c.3.05.6.09.89.15.28.06.57.15.85.23l.72-2.94.08.01.5 1.19.9 2.22c.35.06.7.1 1.04.18.36.08.7.18 1.04.28l-.31-.67c-.48-1-1-2-1.41-3.02 1.12.04 1.98-.36 2.2-1.26.15-.62-.1-1.11-.69-1.53-.43-.31-1.27-.48-1.82-.6l-2.44-.53-1.54 6.3m3.14-5.43c.7.16 1.59.27 1.59 1.07 0 .2-.03.35-.06.48-.23.94-.94 1.26-2.13.9l.6-2.45m8.42 7.34c-.05.7-.18 1.38-.31 2.1.3.15.6.28.9.45.3.16.57.34.86.52l.6-7.23a4.03 4.03 0 01-.78-.43l-6.38 4.05c.17.08.35.16.51.25l.47.28c.54-.45 1.1-.82 1.74-1.3l2.39 1.31zm-1.8-1.65l2.12-1.37-.25 2.4-1.88-1.03"
				fill="#c8b100"
			/>
			<path
				d="M225.2 200.45c0-1.14.97-2.06 2.17-2.06 1.19 0 2.16.92 2.16 2.06 0 1.13-.97 2.05-2.16 2.05-1.2 0-2.17-.92-2.17-2.05z"
				fill="none"
				stroke="#000"
				strokeWidth={0.05}
			/>
			<path
				d="M249.65 182.72c6.64 0 12.56.99 16.4 2.51 2.21 1 5.17 1.73 8.41 2.17 2.47.33 4.81.4 6.85.24 2.73-.06 6.67.74 10.62 2.48 3.26 1.45 5.99 3.2 7.8 4.91l-1.57 1.4-.45 3.96-4.3 4.92-2.15 1.83-5.09 4.07-2.6.21-.79 2.25-32.91-3.86-33.02 3.86-.8-2.25-2.6-.21-5.08-4.07-2.15-1.83-4.3-4.92-.44-3.96-1.58-1.4a28.79 28.79 0 017.8-4.91c3.95-1.74 7.9-2.54 10.62-2.48 2.04.15 4.38.09 6.85-.24a31.2 31.2 0 008.4-2.17c3.86-1.52 9.44-2.5 16.08-2.5z"
				fill="#ad1519"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M250.15 226.18c-12.26-.02-23.25-1.47-31.09-3.83a1.2 1.2 0 01-.84-1.25c0-.52.29-1 .84-1.17 7.84-2.36 18.83-3.81 31.1-3.83 12.26.02 23.23 1.47 31.08 3.83.55.17.84.65.83 1.17a1.2 1.2 0 01-.83 1.25c-7.85 2.36-18.82 3.81-31.09 3.83"
				fill="#c8b100"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M250.12 224.57c-11.06-.01-21.07-1.3-28.68-3.26 7.61-1.97 17.62-3.17 28.68-3.2 11.07.03 21.13 1.23 28.74 3.2-7.61 1.97-17.67 3.25-28.74 3.26"
				fill="#ad1519"
			/>
			<path d="M250.95 224.64v-6.57" fill="none" stroke="#000" strokeWidth={0.09} />
			<path d="M249.16 224.64v-6.57" fill="none" stroke="#000" strokeWidth={0.14} />
			<path d="M247.48 224.64v-6.57" fill="none" stroke="#000" strokeWidth={0.18} />
			<path d="M245.8 224.64v-6.57" fill="none" stroke="#000" strokeWidth={0.23} />
			<path d="M244.32 224.64v-6.57" fill="none" stroke="#000" strokeWidth={0.28} />
			<path
				d="M241.48 224.28l-.03-5.97m1.38 6.05v-6.25"
				fill="none"
				stroke="#000"
				strokeWidth={0.33}
			/>
			<path
				d="M238.87 224.01v-5.5m1.32 5.66l-.04-5.86"
				fill="none"
				stroke="#000"
				strokeWidth={0.37}
			/>
			<path
				d="M235.35 223.7v-4.84m1.15 4.92v-5.08m1.2 5.24v-5.28"
				fill="none"
				stroke="#000"
				strokeWidth={0.42}
			/>
			<path d="M234.12 223.66v-4.68" fill="none" stroke="#000" strokeWidth={0.46} />
			<path d="M232.97 223.42v-4.36" fill="none" stroke="#000" strokeWidth={0.51} />
			<path d="M231.74 223.3v-4.05" fill="none" stroke="#000" strokeWidth={0.56} />
			<path
				d="M229.22 222.95l-.04-3.22m1.33 3.38v-3.62"
				fill="none"
				stroke="#000"
				strokeWidth={0.6}
			/>
			<path d="M227.93 222.68v-2.84" fill="none" stroke="#000" strokeWidth={0.63} />
			<path d="M226.74 222.45v-2.36" fill="none" stroke="#000" strokeWidth={0.68} />
			<path d="M225.45 222.13v-1.84" fill="none" stroke="#000" strokeWidth={0.73} />
			<path d="M224.12 221.98v-1.38" fill="none" stroke="#000" strokeWidth={0.77} />
			<path d="M222.72 221.66V221" fill="none" stroke="#000" strokeWidth={0.91} />
			<path
				d="M258.04 224.28v-6.01m-3.02 6.21l.04-6.37m-2.24 6.45v-6.49"
				fill="none"
				stroke="#000"
				strokeWidth={0.05}
			/>
			<path
				d="M250.07 216.1c-12.41.02-23.55 1.57-31.4 3.99.66-.31.6-1.12-.21-3.2-.98-2.53-2.5-2.42-2.5-2.42 8.66-2.56 20.73-4.16 34.16-4.18 13.44.02 25.6 1.62 34.27 4.18 0 0-1.53-.1-2.5 2.42-.82 2.08-.88 2.89-.22 3.2-7.84-2.42-19.2-3.97-31.6-4"
				fill="#c8b100"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M250.12 210.3c-13.43.02-25.5 1.61-34.16 4.18-.58.17-1.2-.05-1.38-.6-.19-.55.12-1.18.7-1.35 8.7-2.68 21.09-4.35 34.84-4.38 13.77.03 26.2 1.7 34.9 4.38.58.17.89.8.7 1.35-.19.55-.8.77-1.38.6-8.67-2.56-20.78-4.16-34.22-4.19"
				fill="#c8b100"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M250.12 224.57c-11.06-.01-21.07-1.3-28.68-3.26 7.61-1.97 17.62-3.17 28.68-3.2 11.07.03 21.13 1.23 28.74 3.2-7.61 1.97-17.67 3.25-28.74 3.26z"
				fill="none"
				stroke="#000"
				strokeLinejoin="round"
				strokeWidth={0.39}
			/>
			<path
				d="M240.54 213.35c0-.58.5-1.04 1.1-1.04.6 0 1.1.46 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04"
				fill="#fff"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M250.15 214.16h-3.29c-.6 0-1.1-.46-1.1-1.03 0-.58.49-1.04 1.09-1.04h6.64c.6 0 1.1.46 1.1 1.04 0 .57-.5 1.03-1.11 1.03h-3.33"
				fill="#ad1519"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M233.64 215.07l-2.36.27c-.6.07-1.17-.33-1.24-.9-.08-.57.35-1.09.96-1.15l2.37-.28 2.42-.28c.6-.07 1.15.33 1.22.9.07.57-.36 1.09-.96 1.16l-2.41.28"
				fill="#058e6e"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M224.03 215.28c0-.58.5-1.04 1.1-1.04.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.03"
				fill="#fff"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M216.72 217.16l1.22-1.6 3.37.44-2.7 1.96-1.89-.8"
				fill="#ad1519"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M266.66 215.07l2.36.27c.6.07 1.17-.33 1.24-.9a1.05 1.05 0 00-.96-1.15l-2.37-.28-2.42-.28c-.6-.07-1.15.33-1.22.9-.08.57.36 1.09.96 1.16l2.41.28"
				fill="#058e6e"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M257.56 213.35c0-.58.5-1.04 1.1-1.04.6 0 1.1.46 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04m16.51 1.93c0-.58.5-1.04 1.1-1.04.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.03"
				fill="#fff"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M283.57 217.16l-1.21-1.6-3.37.44 2.7 1.96 1.88-.8"
				fill="#ad1519"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M220.12 221.66c7.75-2.17 18.3-3.52 30-3.54 11.71.02 22.31 1.37 30.06 3.54"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M225.34 191.42l1.38 1.11 2.09-3.4a7.7 7.7 0 01-3.75-7.42c.21-4.34 5.5-7.92 12.2-7.92 3.48 0 6.63.95 8.84 2.48.06-.67.12-1.25.21-1.86a18.11 18.11 0 00-9.05-2.28c-7.7 0-13.74 4.38-14.03 9.57a9.25 9.25 0 003.22 7.9l-1.11 1.82"
				fill="#c8b100"
			/>
			<path
				d="M225.34 191.42l1.38 1.11 2.09-3.4a7.7 7.7 0 01-3.75-7.42c.21-4.34 5.5-7.92 12.2-7.92 3.48 0 6.63.95 8.84 2.48.06-.67.12-1.25.21-1.86a18.11 18.11 0 00-9.05-2.28c-7.7 0-13.74 4.38-14.03 9.57a9.25 9.25 0 003.22 7.9l-1.11 1.82"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M225.43 191.46c-2.64-1.97-4.27-4.64-4.27-7.58 0-3.38 2.22-6.4 5.58-8.4a8.84 8.84 0 00-3.56 7.14 9.25 9.25 0 003.26 6.99l-1.01 1.85"
				fill="#c8b100"
			/>
			<path
				d="M225.43 191.46c-2.64-1.97-4.27-4.64-4.27-7.58 0-3.38 2.22-6.4 5.58-8.4a8.84 8.84 0 00-3.56 7.14 9.25 9.25 0 003.26 6.99l-1.01 1.85"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M202.2 194.89a9.16 9.16 0 01-2.37-6.12c0-1.4.32-2.75.91-3.95 2.13-4.38 8.81-7.57 16.76-7.57 2.16 0 4.23.23 6.14.67-.42.46-.75.97-1.08 1.48-1.59-.31-3.29-.48-5.06-.48-7.27 0-13.35 2.83-15.12 6.65a7.36 7.36 0 00-.73 3.2c0 2.32 1.09 4.4 2.8 5.82l-2.64 4.3-1.41-1.12 1.8-2.88"
				fill="#c8b100"
			/>
			<path
				d="M202.2 194.89a9.16 9.16 0 01-2.37-6.12c0-1.4.32-2.75.91-3.95 2.13-4.38 8.81-7.57 16.76-7.57 2.16 0 4.23.23 6.14.67-.42.46-.75.97-1.08 1.48-1.59-.31-3.29-.48-5.06-.48-7.27 0-13.35 2.83-15.12 6.65a7.36 7.36 0 00-.73 3.2c0 2.32 1.09 4.4 2.8 5.82l-2.64 4.3-1.41-1.12 1.8-2.88z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M204.9 180.48a10.98 10.98 0 00-4.16 4.34 8.95 8.95 0 00-.91 3.95c0 2.33.9 4.47 2.38 6.12l-1.6 2.6a10.87 10.87 0 01-2.42-6.7c0-4.2 2.67-7.88 6.71-10.3"
				fill="#c8b100"
			/>
			<path
				d="M204.9 180.48a10.98 10.98 0 00-4.16 4.34 8.95 8.95 0 00-.91 3.95c0 2.33.9 4.47 2.38 6.12l-1.6 2.6a10.87 10.87 0 01-2.42-6.7c0-4.2 2.67-7.88 6.71-10.3z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M250.04 171.27a3.69 3.69 0 013.64 2.72c.23 1.39.38 2.96.41 4.63l-.01.52c0 .2.04.41.05.61.06 3.52.56 6.62 1.27 8.52l-5.36 5.14-5.43-5.14c.72-1.9 1.22-5 1.28-8.52 0-.2.05-.41.05-.61l-.01-.51c.03-1.68.18-3.25.41-4.63.36-1.57 1.94-2.73 3.7-2.73"
				fill="#c8b100"
			/>
			<path
				d="M250.04 171.27a3.69 3.69 0 013.64 2.72c.23 1.39.38 2.96.41 4.63l-.01.52c0 .2.04.41.05.61.06 3.52.56 6.62 1.27 8.52l-5.36 5.14-5.43-5.14c.72-1.9 1.22-5 1.28-8.52 0-.2.05-.41.05-.61l-.01-.51c.03-1.68.18-3.25.41-4.63.36-1.57 1.94-2.73 3.7-2.73z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M250.04 172.94c.91 0 1.69.58 1.87 1.4a30 30 0 01.4 4.37l-.01.48c0 .2.03.4.04.6.05 3.31.53 6.24 1.21 8.04l-3.54 3.35-3.54-3.35c.68-1.8 1.15-4.73 1.21-8.05 0-.2.04-.4.04-.59v-.48c.02-1.58.16-3.07.39-4.38.18-.8 1.02-1.39 1.93-1.39"
				fill="#c8b100"
			/>
			<path
				d="M250.04 172.94c.91 0 1.69.58 1.87 1.4a30 30 0 01.4 4.37l-.01.48c0 .2.03.4.04.6.05 3.31.53 6.24 1.21 8.04l-3.54 3.35-3.54-3.35c.68-1.8 1.15-4.73 1.21-8.05 0-.2.04-.4.04-.59v-.48c.02-1.58.16-3.07.39-4.38.18-.8 1.02-1.39 1.93-1.39z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M274.7 191.42l-1.39 1.11-2.08-3.4a7.71 7.71 0 003.75-7.42c-.21-4.34-5.5-7.92-12.2-7.92-3.5 0-6.63.95-8.84 2.48-.06-.67-.12-1.25-.22-1.86a18.12 18.12 0 019.06-2.28c7.7 0 13.74 4.38 14.03 9.57a9.24 9.24 0 01-3.22 7.9l1.11 1.82"
				fill="#c8b100"
			/>
			<path
				d="M274.7 191.42l-1.39 1.11-2.08-3.4a7.71 7.71 0 003.75-7.42c-.21-4.34-5.5-7.92-12.2-7.92-3.5 0-6.63.95-8.84 2.48-.06-.67-.12-1.25-.22-1.86a18.12 18.12 0 019.06-2.28c7.7 0 13.74 4.38 14.03 9.57a9.24 9.24 0 01-3.22 7.9l1.11 1.82"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M274.61 191.46c2.63-1.97 4.27-4.64 4.27-7.58 0-3.38-2.22-6.4-5.58-8.4a8.87 8.87 0 013.56 7.14 9.24 9.24 0 01-3.27 6.99l1.02 1.85"
				fill="#c8b100"
			/>
			<path
				d="M274.61 191.46c2.63-1.97 4.27-4.64 4.27-7.58 0-3.38-2.22-6.4-5.58-8.4a8.87 8.87 0 013.56 7.14 9.24 9.24 0 01-3.27 6.99l1.02 1.85"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M297.83 194.89a9.02 9.02 0 001.46-10.07c-2.13-4.38-8.8-7.57-16.75-7.57-2.17 0-4.23.23-6.15.67.43.46.76.97 1.09 1.48 1.58-.31 3.29-.48 5.06-.48 7.27 0 13.35 2.83 15.11 6.65.47.97.73 2.06.73 3.2 0 2.32-1.09 4.4-2.79 5.82l2.63 4.3 1.42-1.12-1.8-2.88"
				fill="#c8b100"
			/>
			<path
				d="M297.83 194.89a9.02 9.02 0 001.46-10.07c-2.13-4.38-8.8-7.57-16.75-7.57-2.17 0-4.23.23-6.15.67.43.46.76.97 1.09 1.48 1.58-.31 3.29-.48 5.06-.48 7.27 0 13.35 2.83 15.11 6.65.47.97.73 2.06.73 3.2 0 2.32-1.09 4.4-2.79 5.82l2.63 4.3 1.42-1.12-1.8-2.88z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M295.13 180.48a11.02 11.02 0 014.17 4.34 9.06 9.06 0 01-1.47 10.07l1.6 2.6a10.86 10.86 0 002.41-6.7c0-4.2-2.67-7.88-6.7-10.3"
				fill="#c8b100"
			/>
			<path
				d="M295.13 180.48a11.02 11.02 0 014.17 4.34 9.06 9.06 0 01-1.47 10.07l1.6 2.6a10.86 10.86 0 002.41-6.7c0-4.2-2.67-7.88-6.7-10.3z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M248.13 188.93c0-1 .86-1.8 1.9-1.8 1.06 0 1.91.8 1.91 1.8s-.85 1.8-1.9 1.8c-1.05 0-1.9-.8-1.9-1.8"
				fill="#fff"
			/>
			<path
				d="M248.13 188.93c0-1 .86-1.8 1.9-1.8 1.06 0 1.91.8 1.91 1.8s-.85 1.8-1.9 1.8c-1.05 0-1.9-.8-1.9-1.8z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M248.13 185.4c0-1 .86-1.8 1.9-1.8 1.06 0 1.91.8 1.91 1.8s-.85 1.8-1.9 1.8c-1.05 0-1.9-.8-1.9-1.8m.37-3.8c0-.8.69-1.44 1.53-1.44.83 0 1.51.64 1.51 1.44 0 .8-.68 1.44-1.51 1.44-.84 0-1.53-.64-1.53-1.44m.43-3.43c0-.57.5-1.03 1.1-1.03.6 0 1.09.46 1.09 1.03 0 .58-.49 1.05-1.1 1.05-.6 0-1.09-.47-1.09-1.05m.22-2.99c0-.47.39-.83.88-.83.48 0 .87.37.87.83 0 .45-.4.83-.87.83a.86.86 0 01-.88-.83"
				fill="#fff"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M250.2 199.78l1.23.22a4.8 4.8 0 004.68 6.28 4.9 4.9 0 004.68-3.21c.07.05.46-1.68.67-1.66.17.02.15 1.8.22 1.77.31 2.34 2.46 3.93 4.87 3.93a4.78 4.78 0 004.87-5.22l1.54-1.52.83 1.94c-.33.61-.46 1.3-.46 2.03 0 2.46 2.1 4.44 4.7 4.44 1.62 0 3.05-.78 3.9-1.97l.98-1.25v1.53c0 1.55.65 2.93 2.15 3.18 0 0 1.73.1 4.03-1.7 2.3-1.8 3.56-3.29 3.56-3.29l.2 1.8s-1.91 2.95-3.98 4.15c-1.14.66-2.86 1.35-4.23 1.13-1.44-.24-2.47-1.4-3-2.74a7 7 0 01-3.56.97c-2.8 0-5.33-1.54-6.32-3.86a7.28 7.28 0 01-10.77-.3 7.22 7.22 0 01-4.88 1.86 7.2 7.2 0 01-5.94-3.05 7.19 7.19 0 01-5.94 3.05c-1.89 0-3.61-.71-4.87-1.86a7.27 7.27 0 01-10.77.3c-1 2.32-3.52 3.86-6.32 3.86-1.3 0-2.52-.36-3.55-.97-.54 1.34-1.57 2.5-3.01 2.74-1.37.22-3.1-.47-4.23-1.13-2.07-1.2-3.98-4.14-3.98-4.14l.2-1.8s1.27 1.48 3.56 3.28c2.3 1.8 4.02 1.7 4.02 1.7 1.5-.25 2.16-1.63 2.16-3.18v-1.53l.98 1.25a4.76 4.76 0 003.9 1.97c2.6 0 4.7-1.98 4.7-4.44 0-.73-.14-1.42-.47-2.03l.83-1.94 1.54 1.52-.03.57c0 2.57 2.19 4.65 4.9 4.65 2.42 0 4.56-1.59 4.88-3.93.06.03.05-1.75.22-1.77.2-.02.6 1.7.67 1.66a4.9 4.9 0 004.68 3.21 4.79 4.79 0 004.67-6.28l1.29-.22"
				fill="#c8b100"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M283.96 205.91c.28-.83.03-1.66-.57-1.84-.6-.18-1.32.34-1.6 1.17-.3.83-.04 1.65.56 1.84.6.18 1.32-.34 1.6-1.17m-21.37-4.14c.11-.87-.3-1.63-.93-1.7-.63-.07-1.22.57-1.34 1.44-.11.86.3 1.63.93 1.7.63.07 1.23-.57 1.34-1.44m-24.82 0c-.1-.87.31-1.63.93-1.7.63-.07 1.23.57 1.34 1.44.11.86-.3 1.63-.93 1.7-.63.07-1.22-.57-1.34-1.44m-21.36 4.14c-.3-.83-.04-1.66.56-1.84.6-.18 1.32.34 1.6 1.17.28.83.03 1.65-.57 1.84-.6.18-1.31-.34-1.6-1.17"
				fill="#fff"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M225.68 191.65a5.34 5.34 0 012.3 3.03s.13-.25.71-.6c.6-.32 1.09-.31 1.09-.31s-.17.97-.25 1.32c-.09.34-.1 1.38-.32 2.32a7.72 7.72 0 01-.63 1.68 1.98 1.98 0 00-1.58-.41 1.9 1.9 0 00-1.32.9s-.66-.58-1.2-1.38c-.56-.8-.94-1.78-1.14-2.08-.21-.3-.72-1.15-.72-1.15s.47-.18 1.14-.05c.67.12.88.32.88.32a5.1 5.1 0 011.04-3.59"
				fill="#c8b100"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M226.13 201.86c-.34-.27-.6-.64-.68-1.08a1.7 1.7 0 01.23-1.23s-.88-.44-1.83-.7c-.72-.18-1.99-.19-2.37-.2l-1.15-.02s.07.17.28.55c.26.46.5.75.5.75a5.25 5.25 0 00-3.03 2.09c.99.68 2.3 1.1 3.6.97 0 0-.12.34-.2.86-.06.43-.06.61-.06.61l1.07-.4c.35-.12 1.54-.54 2.15-.95.8-.54 1.49-1.25 1.49-1.25m2.84-.48a1.72 1.72 0 00-.42-2.3s.67-.71 1.47-1.26c.6-.4 1.8-.82 2.15-.95l1.07-.4s0 .18-.06.61c-.08.52-.2.87-.2.87 1.3-.14 2.62.3 3.6.98a5.27 5.27 0 01-3.03 2.08 6.82 6.82 0 00.78 1.3l-1.15-.03c-.38 0-1.65 0-2.37-.2-.95-.25-1.84-.7-1.84-.7"
				fill="#c8b100"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M225.2 200.45c0-1.14.97-2.06 2.17-2.06 1.19 0 2.16.92 2.16 2.06 0 1.13-.97 2.05-2.16 2.05-1.2 0-2.17-.92-2.17-2.05"
				fill="#ad1519"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M250.11 188.37a5.91 5.91 0 011.95 3.8s.19-.26.91-.52 1.28-.16 1.28-.16-.39 1.05-.56 1.42c-.16.37-.38 1.53-.83 2.53a8.58 8.58 0 01-1.05 1.76c-.4-.45-1-.75-1.67-.75-.67 0-1.27.3-1.67.75 0 0-.61-.76-1.06-1.76-.44-1-.66-2.16-.83-2.53-.17-.37-.56-1.42-.56-1.42s.56-.1 1.28.16.92.53.92.53c.1-1.46.86-2.87 1.9-3.81"
				fill="#c8b100"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M248.5 199.83a1.96 1.96 0 01-.01-2.65s-.9-.67-1.9-1.12c-.77-.35-2.18-.59-2.6-.67l-1.28-.24s.04.2.2.67c.2.56.4.93.4.93a6.1 6.1 0 00-3.81 1.76 6.17 6.17 0 003.8 1.75s-.19.36-.39.93c-.16.46-.2.66-.2.66l1.28-.23c.42-.09 1.83-.32 2.6-.67 1-.46 1.9-1.11 1.9-1.11m3.27-.01a1.95 1.95 0 00.01-2.65s.9-.67 1.9-1.12c.77-.35 2.18-.59 2.6-.67l1.28-.24s-.03.2-.2.67c-.2.56-.4.93-.4.93 1.47.08 2.86.81 3.81 1.76a6.15 6.15 0 01-3.8 1.75 7.05 7.05 0 00.59 1.6l-1.27-.24c-.43-.09-1.84-.32-2.6-.67-1-.46-1.92-1.11-1.92-1.11m22.91-8.19a5.36 5.36 0 00-2.3 3.03s-.13-.25-.72-.6c-.58-.32-1.09-.31-1.09-.31s.17.97.26 1.32c.09.34.09 1.38.31 2.32.23.93.64 1.68.64 1.68.42-.34.99-.5 1.57-.41.59.1 1.06.44 1.33.9 0 0 .66-.58 1.2-1.38.55-.8.93-1.78 1.13-2.08.21-.3.72-1.15.72-1.15s-.47-.18-1.14-.05c-.67.12-.88.32-.88.32a5.06 5.06 0 00-1.03-3.59"
				fill="#c8b100"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M274.22 201.86c.34-.27.6-.64.67-1.08.09-.44 0-.87-.22-1.23 0 0 .88-.44 1.82-.7.73-.18 2-.19 2.37-.2l1.15-.02s-.06.17-.28.55c-.26.46-.5.75-.5.75a5.26 5.26 0 013.04 2.09 5.5 5.5 0 01-3.6.97s.11.34.2.86c.06.43.05.61.05.61l-1.06-.4c-.36-.12-1.55-.54-2.16-.95-.8-.54-1.48-1.25-1.48-1.25m-2.84-.48a1.74 1.74 0 01-.25-1.23c.09-.44.33-.8.67-1.08 0 0-.67-.7-1.47-1.25-.61-.4-1.8-.82-2.16-.95l-1.06-.4s0 .18.06.61c.08.52.2.87.2.87-1.3-.14-2.62.3-3.6.98a5.27 5.27 0 003.02 2.08s-.23.28-.49.74c-.22.39-.28.56-.28.56l1.14-.03c.38 0 1.66 0 2.37-.2.95-.25 1.84-.7 1.84-.7"
				fill="#c8b100"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M270.81 200.45c0-1.14.97-2.06 2.17-2.06s2.17.92 2.17 2.06c0 1.13-.97 2.05-2.17 2.05s-2.17-.92-2.17-2.05m24.24 4.55c-.5-.53-1.57-.42-2.36.26-.79.67-1.02 1.66-.5 2.2.5.53 1.56.41 2.35-.26.8-.67 1.02-1.66.51-2.2"
				fill="#ad1519"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M291.97 206.31c.11-.36.36-.74.72-1.05.8-.68 1.85-.8 2.36-.25.06.07.14.17.18.25 0 0 1.1-2.08 2.4-2.78 1.3-.7 3.5-.52 3.5-.52 0-1.6-1.3-2.89-3-2.89-.99 0-1.92.41-2.48 1.1l-.22-1.06s-1.36.27-1.98 1.82c-.62 1.55.05 3.8.05 3.8s-.33-.96-.84-1.6a8.33 8.33 0 00-2.49-1.66 11.2 11.2 0 01-1.37-.8s-.03.18-.06.6c-.02.52.02.84.02.84a8.21 8.21 0 00-3.83.48c.48.95 1.4 1.84 2.61 2.3 0 0-.43.36-.83.75-.33.34-.44.5-.44.5l1.28.18c.43.05 1.84.28 2.68.22.63-.04 1.32-.14 1.74-.22m-83.6-.01c-.1-.36-.35-.74-.72-1.05-.79-.68-1.84-.8-2.36-.25a1.1 1.1 0 00-.17.25s-1.1-2.08-2.4-2.78c-1.3-.7-3.5-.52-3.5-.52 0-1.6 1.3-2.89 2.99-2.89 1 0 1.92.41 2.48 1.1l.23-1.06s1.36.27 1.98 1.82c.62 1.55-.06 3.8-.06 3.8s.34-.96.85-1.6a8.36 8.36 0 012.49-1.66c.67-.32 1.37-.8 1.37-.8a8.21 8.21 0 00.04 1.44c1.24-.17 2.7.04 3.83.48a4.92 4.92 0 01-2.62 2.3s.44.36.83.75c.34.34.44.5.44.5l-1.27.18c-.43.05-1.84.28-2.69.22-.62-.04-1.32-.14-1.74-.22"
				fill="#c8b100"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M205.3 205c.5-.53 1.56-.42 2.35.26.8.67 1.02 1.66.51 2.2-.5.53-1.57.41-2.36-.26-.79-.67-1.02-1.66-.5-2.2m42.67-6.5c0-1.13.97-2.05 2.17-2.05s2.17.92 2.17 2.05c0 1.14-.97 2.06-2.17 2.06s-2.17-.92-2.17-2.06"
				fill="#ad1519"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M245.63 167.3c0-2.32 1.98-4.2 4.42-4.2a4.32 4.32 0 014.43 4.2 4.31 4.31 0 01-4.43 4.2 4.32 4.32 0 01-4.43-4.2"
				fill="#005bbf"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M248.9 155.54v2.26h-2.43v2.3h2.42v6.6h-3.05c-.03.21-.22.37-.22.6 0 .57.12 1.13.35 1.63 0 .02.02.02.03.03h8.12l.03-.03a4 4 0 00.34-1.63c0-.23-.18-.39-.22-.6h-2.95v-6.61h2.42v-2.3h-2.42v-2.26h-2.43z"
				fill="#c8b100"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M250.5 344.33a85.31 85.31 0 01-36.96-8.54 23.65 23.65 0 01-13.36-21.19v-33.3h100.43v33.3c0 9.19-5.33 17.21-13.37 21.2a84.42 84.42 0 01-36.75 8.53"
				fill="#ccc"
			/>
			<path
				d="M250.5 344.33a85.31 85.31 0 01-36.96-8.54 23.65 23.65 0 01-13.36-21.19v-33.3h100.43v33.3c0 9.19-5.33 17.21-13.37 21.2a84.42 84.42 0 01-36.75 8.53z"
				fill="none"
				stroke="#000"
				strokeWidth={0.52}
			/>
			<path d="M250.28 281.25h50.32v-55.72h-50.32v55.72z" fill="#ccc" />
			<path
				d="M250.28 281.25h50.32v-55.72h-50.32v55.72z"
				fill="none"
				stroke="#000"
				strokeWidth={0.52}
			/>
			<path
				d="M250.32 314.57c0 13.16-11.16 23.82-25.05 23.82-13.9 0-25.16-10.66-25.16-23.82V281.2h50.2v33.36"
				fill="#ad1519"
			/>
			<path
				d="M211.08 334.23c1.57.83 3.72 2.22 6.03 2.77l-.15-56.96h-5.88v54.19z"
				fill="#c8b100"
				stroke="#000"
				strokeWidth={0.52}
			/>
			<path
				d="M200.03 314.12a25.4 25.4 0 005.73 15.67v-49.47h-5.66l-.07 33.8z"
				fill="#c8b100"
				stroke="#000"
				strokeLinejoin="round"
				strokeWidth={0.5}
			/>
			<path
				d="M222.28 338.25c2.3.23 4.01.19 5.87 0v-58.21h-5.88v58.21z"
				fill="#c7b500"
				stroke="#000"
				strokeWidth={0.52}
			/>
			<path
				d="M233.32 337c2.3-.46 4.9-1.9 6.03-2.63v-54.33h-5.88l-.15 56.96z"
				fill="#c8b100"
				stroke="#000"
				strokeWidth={0.52}
			/>
			<path d="M200.12 281.25h50.18v-55.72h-50.18v55.72z" fill="#ad1519" />
			<path
				d="M200.12 281.25h50.18v-55.72h-50.18v55.72z"
				fill="none"
				stroke="#000"
				strokeWidth={0.52}
			/>
			<path
				d="M244.81 329.24c2.45-2.18 4.75-7.13 5.59-12.76l.14-36.44h-5.87l.14 49.2z"
				fill="#c8b100"
				stroke="#000"
				strokeWidth={0.52}
			/>
			<path
				d="M250.32 314.57c0 13.16-11.16 23.82-25.05 23.82-13.9 0-25.16-10.66-25.16-23.82V281.2h50.2v33.36"
				fill="none"
				stroke="#000"
				strokeWidth={0.52}
			/>
			<path
				d="M300.65 281.21v33.36c0 13.16-11.28 23.82-25.17 23.82-13.9 0-25.16-10.66-25.16-23.82V281.2h50.33"
				fill="#ad1519"
			/>
			<path
				d="M300.65 281.21v33.36c0 13.16-11.28 23.82-25.17 23.82-13.9 0-25.16-10.66-25.16-23.82V281.2h50.33"
				fill="none"
				stroke="#000"
				strokeWidth={0.52}
			/>
			<path
				d="M259.47 306.39c.08.17.13.34.13.52 0 .61-.52 1.1-1.17 1.1-.65 0-1.17-.49-1.17-1.1 0-.18.04-.35.12-.5l-1.63-.02a2.6 2.6 0 001.85 2.99v4.01l1.71.01v-4.04c.8-.26 1.43-.86 1.7-1.62h4.6v-1.35h-6.14m22.58 0v1.35l-4.14.01c-.06.19-.16.35-.26.51l4.8 5.46-1.29 1.05-4.78-5.47-.23.09v9.04h-1.7v-9.08a.61.61 0 01-.2-.09l-4.98 5.5-1.3-1.04 4.98-5.52c-.08-.14-.15-.3-.2-.46h-4.28v-1.35h13.59zm2.76 0v1.35h4.6c.28.76.9 1.36 1.7 1.62v4.04h1.71v-4.02a2.6 2.6 0 001.91-2.47c0-.18-.02-.36-.06-.52h-1.63c.08.17.12.34.12.52 0 .61-.52 1.1-1.16 1.1-.65 0-1.17-.49-1.17-1.1 0-.18.04-.35.12-.5l-6.14-.02m-6.96 23.04c1.34-.21 2.58-.58 3.8-1.1l.85 1.43c-1.41.6-2.93 1.04-4.5 1.28a2.7 2.7 0 01-2.67 2.04 2.7 2.7 0 01-2.67-2.02 18.23 18.23 0 01-4.73-1.3l.84-1.43c1.29.55 2.66.9 4.08 1.1a2.6 2.6 0 011.58-1.38l.01-7.01h1.7l.01 6.98c.75.22 1.38.74 1.7 1.4zm-11.5-2.35l-.83 1.44a17.35 17.35 0 01-3.8-3.22c-.86.26-1.85.1-2.59-.5a2.49 2.49 0 01-.3-3.64l.14-.16a15.9 15.9 0 01-1.32-5h1.71c.13 1.51.51 2.94 1.1 4.28.48-.06.99 0 1.45.16l4.28-4.73 1.29 1.04-4.25 4.73c.57.87.55 2-.1 2.85a15.8 15.8 0 003.23 2.75zm-6.33-4.96a1.21 1.21 0 011.65-.13c.49.4.55 1.1.13 1.56-.42.47-1.16.52-1.65.13-.5-.4-.55-1.1-.13-1.56zm-2.16-4.69l-1.76-.39-.25-4.45 1.75-.58v2.56c0 .99.09 1.92.26 2.86zm1.46-5.52l1.75.41s.09 2.87.05 2.22c-.04-.75.2 2.24.2 2.24l-1.77.58c-.18-.9-.24-1.84-.24-2.8v-2.65zm5.77 14.25a16.32 16.32 0 005.04 2.68l.4-1.7a14.27 14.27 0 01-4.18-2.1l-1.26 1.12m-.84 1.46c1.5 1.13 3.2 2.03 5.04 2.65l-1.31 1.23a19.49 19.49 0 01-4.12-2.11l.38-1.77m2.29-9.81l1.67.7 3.06-3.39-1-1.44-3.73 4.13m-1.3-1.05l-1-1.45 3.06-3.4 1.67.72-3.73 4.13m18.84 10.32l.83 1.44a17.4 17.4 0 003.8-3.22c.87.26 1.85.1 2.6-.5a2.5 2.5 0 00.3-3.64l-.15-.16c.7-1.56 1.17-3.24 1.32-5h-1.7c-.14 1.51-.52 2.94-1.1 4.28-.48-.06-1 0-1.46.16l-4.27-4.73-1.3 1.04 4.26 4.73c-.57.87-.55 2 .1 2.85a15.71 15.71 0 01-3.23 2.75zm6.34-4.96a1.2 1.2 0 00-1.65-.13c-.5.4-.55 1.1-.13 1.56.42.47 1.16.52 1.65.13.5-.4.55-1.1.13-1.56zm2.15-4.69l1.76-.39.25-4.45-1.74-.58v2.56c0 .99-.1 1.92-.27 2.86zm-1.45-5.52l-1.75.41s-.1 2.87-.06 2.22c.05-.75-.2 2.24-.2 2.24l1.77.58c.18-.9.24-1.84.24-2.8v-2.65m-5.78 14.25a16.38 16.38 0 01-5.04 2.68l-.39-1.7a14.24 14.24 0 004.17-2.1l1.26 1.12m.85 1.46a18.18 18.18 0 01-5.04 2.65l1.31 1.23a19.5 19.5 0 004.12-2.11l-.39-1.77m-2.28-9.81l-1.67.7-3.06-3.39 1-1.44 3.73 4.13m1.3-1.05l1-1.45-3.06-3.4-1.67.72 3.72 4.13m-20.94-9.01l.51 1.67h4.72l.5-1.67h-5.73m22.02 0l-.52 1.67h-4.71l-.5-1.67h5.73m-12.11 22.75c0-.62.52-1.12 1.17-1.12.64 0 1.17.5 1.17 1.12 0 .6-.53 1.1-1.17 1.1-.65 0-1.17-.5-1.17-1.1zm1.98-8.08l1.76-.5v-4.45l-1.76-.48v5.43m-1.7 0l-1.76-.5v-4.45l1.76-.48v5.43"
				fill="#c8b100"
			/>
			<path
				d="M255.75 306.43c.2-.93.93-1.69 1.86-1.97l-.01-5.5h1.7v5.53c.84.26 1.48.88 1.74 1.68h4.57v.26h-6.14a1.2 1.2 0 00-2.09.02l-1.63-.02m12.71 0v-.25h4.25c.05-.14.11-.28.19-.4l-5.25-5.85 1.3-1.04 5.17 5.75.27-.12.01-7.66h1.7v7.61l.26.07 5.06-5.76 1.3 1.03-5.08 5.74c.13.19.22.4.3.63h4.1v.25h-13.58zm22.5 0a1.2 1.2 0 011.04-.6c.45 0 .85.26 1.04.62l1.63-.02a2.68 2.68 0 00-1.86-1.97l.01-5.5h-1.7v5.54c-.83.26-1.48.87-1.73 1.67h-4.58v.26h6.14m-31.38-15.54l6.3 7.07 1.3-1.05-6.34-7.04c.12-.19.21-.4.29-.62h4.61v-1.6h-4.61a2.72 2.72 0 00-2.61-1.8 2.67 2.67 0 00-2.73 2.6c0 1.13.76 2.1 1.84 2.45l-.01 5.45h1.69v-5.42l.27-.04zm33.27.03l-.01 5.43h-1.7v-5.45c-.13-.04-.26-.1-.38-.15l-6.27 7.07-1.3-1.03 6.4-7.21c-.06-.1-.12-.21-.15-.33h-4.64v-1.6h4.62a2.71 2.71 0 012.6-1.8c1.5 0 2.73 1.17 2.73 2.6a2.6 2.6 0 01-1.9 2.47zm-16.73-.02l-.01 3.35h-1.7v-3.32a2.68 2.68 0 01-1.78-1.68h-4.13v-1.6h4.13a2.7 2.7 0 012.6-1.8c1.2 0 2.23.75 2.6 1.8h4.21v1.6h-4.23a2.63 2.63 0 01-1.69 1.65zm-18.49 4.06l-1.76.5v4.46l1.76.49v-5.45m1.7 0l1.76.5v4.46l-1.75.49v-5.45m31.78 0l-1.75.5v4.46l1.75.49v-5.45m1.71 0l1.76.5v4.46l-1.76.49v-5.45m-26.61.88l1.67-.7 3.06 3.4-1 1.44-3.73-4.14m-1.3 1.06l-1 1.45 3.06 3.4 1.67-.72-3.73-4.13m19.22-1.19l-1.68-.7-3.03 3.43 1.02 1.44 3.69-4.17m1.3 1.04l1.02 1.45-3.03 3.42-1.68-.7 3.7-4.17m-21.19 9.43l.51-1.67h4.72l.5 1.67h-5.73m-6.91-17.73c0-.61.52-1.11 1.17-1.11.64 0 1.17.5 1.17 1.11 0 .61-.53 1.1-1.17 1.1-.65 0-1.17-.49-1.17-1.1zm12.6.8l-.51 1.68h-4.71l-.51-1.67h5.74m0-1.62l-.52-1.67h-4.71l-.51 1.67h5.74m16.32 18.54l-.52-1.67h-4.71l-.5 1.67h5.73m4.57-17.73c0-.61.52-1.11 1.17-1.11.64 0 1.16.5 1.16 1.11 0 .61-.52 1.1-1.16 1.1-.65 0-1.17-.49-1.17-1.1zm-16.8 0c0-.61.53-1.11 1.17-1.11.65 0 1.17.5 1.17 1.11 0 .61-.52 1.1-1.17 1.1-.64 0-1.17-.49-1.17-1.1zm6.53.8l.52 1.68h4.7l.52-1.67h-5.74m0-1.62l.52-1.67h4.7l.52 1.67h-5.74m-6.15 5.22l-1.76.5v4.46l1.76.49v-5.45m1.69 0l1.75.5v4.46l-1.75.49v-5.45"
				fill="#c8b100"
			/>
			<path
				d="M277.85 329.43c1.34-.21 2.58-.58 3.8-1.1l.85 1.43c-1.41.6-2.93 1.04-4.5 1.28a2.7 2.7 0 01-2.67 2.04 2.7 2.7 0 01-2.67-2.02 18.23 18.23 0 01-4.73-1.3l.84-1.43c1.29.55 2.66.9 4.08 1.1a2.6 2.6 0 011.58-1.38l.01-7.01h1.7l.01 6.98c.75.22 1.38.74 1.7 1.4zm-4.9-21.23c-.09-.14-.15-.3-.2-.46h-4.29v-1.6h4.25c.05-.14.12-.27.19-.4l-5.25-5.83 1.3-1.05 5.17 5.74.28-.12v-7.64h1.7v7.6c.07.02.19.04.26.07l5.06-5.75 1.3 1.03-5.08 5.72c.13.19.22.4.3.63h4.1v1.6l-4.13.01c-.06.19-.17.35-.26.51l4.8 5.47-1.29 1.04-4.78-5.47c-.09.03-.13.07-.23.1l-.01 9.03h-1.7v-9.08a.882.882 0 01-.2-.09l-4.98 5.51-1.29-1.04 4.98-5.53m-13.38-17.32l6.3 7.05 1.3-1.04-6.34-7.03c.12-.19.21-.4.29-.61h4.61v-1.6h-4.61a2.72 2.72 0 00-2.61-1.8 2.66 2.66 0 00-2.73 2.6c0 1.12.76 2.09 1.84 2.44l-.01 5.44h1.69v-5.4c.07-.03.2-.03.27-.05zm6.79 36.2l-.84 1.44a17.35 17.35 0 01-3.8-3.22c-.86.26-1.85.1-2.59-.5a2.49 2.49 0 01-.3-3.64l.14-.16a15.9 15.9 0 01-1.32-5h1.71c.13 1.51.51 2.94 1.1 4.28.48-.06.99 0 1.45.16l4.28-4.73 1.29 1.04-4.25 4.73c.57.87.55 2-.1 2.85a15.8 15.8 0 003.23 2.75zm-8.76-13.69v-4.01a2.6 2.6 0 01-1.9-2.47c0-1.16.8-2.15 1.91-2.48l-.01-5.5h1.7v5.53c.84.26 1.48.88 1.74 1.67h4.57v1.61h-4.6c-.27.76-.9 1.36-1.7 1.62v4.04h-1.71m2.42 8.72a1.21 1.21 0 011.65-.13c.49.4.55 1.1.13 1.56-.42.47-1.16.52-1.65.13-.5-.4-.55-1.1-.13-1.56zm-2.16-4.69l-1.76-.39-.25-4.45 1.75-.58v2.56c0 .99.09 1.92.26 2.86zm1.46-5.52l1.75.41s.09 2.87.05 2.22c-.04-.75.2 2.24.2 2.24l-1.77.58c-.18-.9-.24-1.84-.24-2.8v-2.65zm5.77 14.25a16.32 16.32 0 005.04 2.68l.4-1.7a14.27 14.27 0 01-4.18-2.1l-1.26 1.12m-.84 1.46c1.5 1.13 3.2 2.03 5.04 2.65l-1.31 1.23a19.49 19.49 0 01-4.12-2.11l.38-1.77"
				fill="none"
				stroke="#c8b100"
				strokeWidth={0.26}
			/>
			<path
				d="M266.53 317.8l1.67.72 3.06-3.4-1-1.44-3.73 4.13m-1.3-1.05l-1-1.45 3.06-3.4 1.67.72-3.73 4.13m-7.97-9.85c0-.62.52-1.11 1.17-1.11.64 0 1.16.5 1.16 1.11 0 .61-.52 1.1-1.16 1.1-.65 0-1.17-.49-1.17-1.1zm26.8 20.17l.84 1.44a17.4 17.4 0 003.8-3.22c.87.26 1.85.1 2.6-.5a2.5 2.5 0 00.3-3.64l-.15-.16c.7-1.56 1.17-3.24 1.32-5h-1.7c-.14 1.51-.52 2.94-1.1 4.28-.48-.06-1 0-1.46.16l-4.27-4.73-1.3 1.04 4.26 4.73c-.57.87-.55 2 .1 2.85a15.71 15.71 0 01-3.23 2.75zm8.77-13.69v-4.01a2.6 2.6 0 001.9-2.47c0-1.16-.81-2.15-1.92-2.48l.01-5.5h-1.7v5.53c-.83.26-1.48.88-1.73 1.67h-4.58v1.61h4.6c.28.76.9 1.36 1.7 1.62v4.04h1.71zm-2.42 8.73a1.2 1.2 0 00-1.65-.13c-.5.4-.55 1.1-.13 1.56.42.47 1.16.52 1.65.13.5-.4.55-1.1.13-1.56zm2.15-4.69l1.76-.39.25-4.45-1.74-.58v2.56c0 .99-.1 1.92-.27 2.86zm-1.45-5.52l-1.75.41s-.1 2.87-.06 2.22c.05-.75-.2 2.24-.2 2.24l1.77.58c.18-.9.24-1.84.24-2.8v-2.65m1.73-21l-.01 5.42h-1.7v-5.44c-.13-.04-.26-.1-.38-.15l-6.27 7.06-1.3-1.03 6.4-7.2c-.06-.1-.12-.2-.15-.32h-4.64v-1.6h4.62a2.71 2.71 0 012.6-1.8c1.5 0 2.73 1.16 2.73 2.6a2.6 2.6 0 01-1.9 2.46zm-16.73-.02l-.01 3.34h-1.7v-3.31a2.68 2.68 0 01-1.78-1.67h-4.13v-1.6h4.13a2.7 2.7 0 012.6-1.8c1.2 0 2.23.75 2.6 1.8h4.21v1.6h-4.23a2.63 2.63 0 01-1.69 1.64zm9.22 35.27a16.38 16.38 0 01-5.04 2.68l-.39-1.7a14.24 14.24 0 004.17-2.1l1.26 1.12m.85 1.46a18.18 18.18 0 01-5.04 2.65l1.31 1.23a19.5 19.5 0 004.12-2.11l-.39-1.77m-28.56-32.68l-1.76.5v4.46l1.76.48v-5.44m1.7 0l1.76.5v4.46l-1.75.48v-5.44m31.78 0l-1.75.5v4.46l1.75.48v-5.44"
				fill="none"
				stroke="#c8b100"
				strokeWidth={0.26}
			/>
			<path
				d="M292.82 294.94l1.76.5v4.46l-1.76.48v-5.44m-8.92 22.87l-1.67.7-3.06-3.39 1-1.44 3.73 4.13m1.3-1.05l1-1.45-3.06-3.4-1.67.72 3.72 4.13m-18.98-20.94l1.67-.7 3.06 3.39-1 1.45-3.73-4.14m-1.3 1.05l-1 1.46 3.06 3.39 1.67-.72-3.73-4.13m19.22-1.18l-1.68-.7-3.03 3.43 1.02 1.43 3.69-4.16m1.3 1.04l1.02 1.44-3.03 3.42-1.68-.7 3.7-4.16m-21.19 9.4l.51-1.66h4.72l.5 1.67h-5.73m0 1.6l.51 1.68h4.72l.5-1.67h-5.73m-6.91-19.3c0-.62.52-1.11 1.17-1.11.64 0 1.17.5 1.17 1.1 0 .62-.53 1.1-1.17 1.1-.65 0-1.17-.48-1.17-1.1zm12.6.8l-.51 1.67h-4.71l-.51-1.67h5.74m0-1.62l-.52-1.66h-4.71l-.51 1.66h5.74m20.88 19.28c0-.62.52-1.11 1.17-1.11.64 0 1.16.5 1.16 1.11 0 .61-.52 1.1-1.16 1.1-.65 0-1.17-.49-1.17-1.1zm-4.56-.77l-.52-1.67h-4.71l-.5 1.67h5.73m0 1.6l-.52 1.68h-4.71l-.5-1.67h5.73m-12.11 22.75c0-.62.52-1.12 1.17-1.12.64 0 1.17.5 1.17 1.12 0 .6-.53 1.1-1.17 1.1-.65 0-1.17-.5-1.17-1.1zm1.98-8.08l1.76-.5v-4.45l-1.76-.48v5.43m-1.7 0l-1.76-.5v-4.45l1.76-.48v5.43m16.4-33.98c0-.6.52-1.1 1.17-1.1.64 0 1.16.5 1.16 1.1 0 .62-.52 1.1-1.16 1.1-.65 0-1.17-.48-1.17-1.1zm-16.8 0c0-.6.53-1.1 1.17-1.1.65 0 1.17.5 1.17 1.1 0 .62-.52 1.1-1.17 1.1-.64 0-1.17-.48-1.17-1.1zm6.53.81l.52 1.67h4.7l.52-1.67h-5.74m0-1.62l.52-1.66h4.7l.52 1.66h-5.74m-6.15 5.22l-1.76.49v4.46l1.76.48v-5.43m1.69 0l1.75.49v4.46l-1.75.48v-5.43"
				fill="none"
				stroke="#c8b100"
				strokeWidth={0.26}
			/>
			<path
				d="M272.6 306.94c0-1.44 1.22-2.6 2.73-2.6 1.5 0 2.73 1.16 2.73 2.6a2.66 2.66 0 01-2.73 2.58c-1.51 0-2.74-1.15-2.74-2.58"
				fill="#058e6e"
			/>
			<path
				d="M275.93 239.26l.06-.62.08-.34s-1.61.13-2.46-.1a6.15 6.15 0 01-2.4-1.26c-.8-.68-1.1-1.1-1.67-1.18-1.36-.22-2.4.4-2.4.4s1.02.37 1.78 1.3a4.85 4.85 0 001.95 1.54c.6.18 2.66.05 3.22.07.57.03 1.84.2 1.84.2"
				fill="#db4446"
			/>
			<path
				d="M275.93 239.26l.06-.62.08-.34s-1.61.13-2.46-.1a6.15 6.15 0 01-2.4-1.26c-.8-.68-1.1-1.1-1.67-1.18-1.36-.22-2.4.4-2.4.4s1.02.37 1.78 1.3a4.85 4.85 0 001.95 1.54c.6.18 2.66.05 3.22.07.57.03 1.84.2 1.84.2z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M283.46 237s0 .72.08 1.4c.06.67-.22 1.24-.1 1.61.1.37.15.66.3.93.13.26.2.94.2.94l-.74-.54c-.35-.27-.6-.44-.6-.44l.1 1.03c.04.31.22.9.51 1.24.29.33.87.89 1.05 1.33.18.45.14 1.44.14 1.44s-.46-.75-.87-.89c-.4-.14-1.26-.62-1.26-.62s.8.8.8 1.55-.33 1.6-.33 1.6-.36-.68-.83-1.13c-.47-.44-1.13-.89-1.13-.89s.52 1.17.52 1.95c0 .8-.15 2.47-.15 2.47s-.4-.64-.8-.96c-.4-.3-.86-.58-1-.78-.15-.2.46.64.53 1.16.07.51.32 2.35 1.92 4.7.94 1.36 2.39 3.76 5.5 2.97 3.11-.78 1.95-4.97 1.3-6.92a17.52 17.52 0 01-.94-4.87c.04-.75.58-2.97.5-3.39-.06-.4-.23-2 .15-3.28.4-1.33.73-1.85.94-2.4.22-.55.4-.86.47-1.34.07-.48.07-1.37.07-1.37s.58 1.06.72 1.44c.15.38.15 1.5.15 1.5s.1-1.12.98-1.67c.87-.55 1.88-1.13 2.13-1.44.25-.31.33-.51.33-.51s-.08 1.92-.62 2.67c-.36.5-1.77 2.1-1.77 2.1s.73-.29 1.23-.31c.5-.04.87 0 .87 0s-.62.48-1.41 1.64c-.8 1.16-.47 1.26-1.05 2.22-.58.96-1.05 1-1.78 1.58-1.08.87-.5 4.34-.36 4.86.15.51 2.03 4.76 2.07 5.8.03 1.02.21 3.32-1.6 4.79-1.16.95-3.07.96-3.5 1.23-.44.28-1.3 1.13-1.3 2.91 0 1.79.64 2.06 1.15 2.5.5.45 1.16.21 1.3.56.15.34.22.54.44.75.22.2.36.44.29.82-.07.38-.9 1.23-1.2 1.85-.29.61-.87 2.23-.87 2.47 0 .24-.06 1 .18 1.37 0 0 .9 1.06.3 1.26-.4.14-.8-.25-.98-.2-.54.14-.82.47-.98.44-.36-.06-.36-.24-.4-.75-.03-.51-.01-.72-.18-.72-.21 0-.32.18-.36.45-.04.27-.04.89-.29.89-.25 0-.61-.45-.83-.55-.22-.1-.83-.2-.87-.48-.03-.27.36-.85.76-.96.4-.1.76-.3.5-.5-.25-.21-.5-.21-.75 0-.25.2-.8.03-.76-.28.04-.31.1-.69.07-.86-.03-.17-.47-.51.1-.82.59-.3.84.27 1.42.17s.87-.31 1.08-.65c.22-.34.18-1.06-.21-1.5-.4-.45-.8-.52-.95-.8-.14-.27-.36-.92-.36-.92s.1 1.2.04 1.37c-.07.17-.04.89-.04.89l-.72-.79a5.1 5.1 0 01-.65-1.37l-.03 1.34c0 .37.43.72.29.86-.15.13-.83-.72-1.02-.86a3.81 3.81 0 01-1.01-1.06c-.25-.48-.44-1.16-.5-1.4-.08-.25-.2-1.32-.08-1.59.18-.4.47-1.13.47-1.13h-1.41c-.76 0-1.3-.23-1.6.28-.28.51-.14 1.54.22 2.88.37 1.33.58 1.98.48 2.22-.11.24-.58.8-.76.9-.19.1-.7.06-.91-.04a2.6 2.6 0 00-1.26-.27c-.69 0-1.12.03-1.38-.03-.25-.07-.87-.38-1.16-.31-.29.07-.79.32-.65.72.22.61-.21.75-.5.72-.3-.04-.54-.14-.91-.24-.36-.1-.9 0-.83-.42.07-.4.22-.44.4-.75.18-.3.25-.5.04-.53-.25-.02-.5-.05-.7.11-.2.16-.5.5-.76.38-.26-.14-.46-.43-.46-1.08 0-.64-.68-1.2-.05-1.17.62.03 1.41.48 1.55.13.14-.35.06-.5-.28-.78-.34-.26-.76-.43-.3-.77.44-.35.55-.35.73-.54.17-.18.4-.79.72-.64.63.3.03.73.66 1.42.62.7 1.01.94 2.06.83 1.04-.1 1.33-.24 1.33-.54 0-.3-.09-.82-.12-1.04-.02-.21.15-1 .15-1s-.48.3-.63.6c-.13.3-.42.8-.42.8s-.11-.6-.08-1.1c.02-.28.12-.78.11-.88-.03-.27-.22-.94-.22-.94s-.18.73-.29.94c-.1.21-.17 1.07-.17 1.07s-.66-.58-.47-1.55c.13-.75-.12-1.74.1-2.06.23-.33.77-1.64 2.07-1.7 1.3-.04 2.31.06 2.77.04.45-.03 2.06-.32 2.06-.32s-2.97-1.53-3.65-1.99a9.89 9.89 0 01-2.06-2.16c-.34-.54-.65-1.58-.65-1.58s-.53.03-1.02.3a5.13 5.13 0 00-1.97 2.03s.08-.94.08-1.24c0-.28-.06-.85-.06-.85s-.33 1.28-1.01 1.76c-.68.49-1.47 1.15-1.47 1.15s.08-.71.08-.88c0-.16.17-.99.17-.99s-.48.72-1.21.86c-.74.13-1.81.1-1.9.56-.08.45.2 1.07.03 1.4-.17.31-.54.53-.54.53s-.42-.35-.79-.38c-.36-.03-.7.16-.7.16s-.32-.4-.2-.67c.11-.26.68-.66.54-.83-.15-.16-.6.06-.88.2-.28.13-.88.26-.82-.2.06-.45.2-.72.06-1.04-.15-.32-.06-.53.17-.62.22-.07 1.13.03 1.21-.18.08-.21-.22-.48-.82-.61-.6-.14-.88-.49-.56-.78.3-.3.4-.38.53-.64.14-.27.2-.75.74-.51.53.24.42.82.99 1.01.56.2 1.89-.07 2.17-.23.29-.17 1.19-.84 1.5-1 .31-.16 1.6-1.12 1.6-1.12s-.75-.53-1.04-.8c-.28-.27-.78-.91-1.04-1.05a8.72 8.72 0 00-1.92-.64 12 12 0 01-1.73-.48s.6-.19.8-.35c.2-.16.64-.56.87-.53l.28.03s-1.21-.06-1.47-.14c-.25-.08-.99-.54-1.27-.54s-.84.11-.84.11.76-.48 1.38-.59c.62-.1 1.1-.08 1.1-.08s-.96-.26-1.19-.58c-.22-.33-.45-.8-.62-1.02-.17-.21-.28-.56-.6-.59-.3-.03-.84.38-1.15.35-.3-.02-.54-.22-.57-.67-.02-.46 0-.3-.1-.53-.12-.25-.57-.81-.15-.94.43-.14 1.33.08 1.42-.08.08-.16-.48-.65-.85-.83-.37-.19-.96-.51-.65-.78.31-.27.62-.37.8-.61.16-.24.36-.91.73-.7.36.21.87 1.26 1.16 1.18.28-.08.3-.83.25-1.15-.06-.32 0-.88.28-.83.28.05.5.43.96.46.45.02 1.13-.11 1.07.2-.05.33-.3.72-.62 1.08a1.6 1.6 0 00-.25 1.5c.2.45.7 1.18 1.16 1.47.45.3 1.3.5 1.84.85.53.36 1.78 1.34 2.2 1.45.42.1.85.32.85.32s.48-.21 1.13-.21c.65 0 2.15.1 2.71-.14.57-.24 1.3-.64 1.08-1.15-.23-.5-1.47-.96-1.36-1.36.11-.4.57-.43 1.33-.46.76-.02 1.8.14 2-.94.2-1.06.25-1.68-.81-1.92-1.08-.24-1.87-.27-2.07-1.04-.2-.78-.4-.97-.17-1.18.23-.21.62-.32 1.41-.37.8-.06 1.7-.06 1.95-.25.26-.18.31-.7.62-.91.31-.21 1.53-.4 1.53-.4s1.45.7 2.8 1.7c1.21.91 2.3 2.24 2.3 2.24"
				fill="#ed72aa"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path d="M273.05 236.24s-.17-.48-.2-.62c-.03-.13-.12-.29-.12-.29s.88 0 .85.27c-.02.27-.28.27-.33.37-.06.1-.2.27-.2.27" />
			<path
				d="M273.05 236.24s-.17-.48-.2-.62c-.03-.13-.12-.29-.12-.29s.88 0 .85.27c-.02.27-.28.27-.33.37-.06.1-.2.27-.2.27z"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path d="M277.06 234.85l-.06-.43s.77 0 1.13.26c.57.4.93 1.02.9 1.05-.09.1-.53-.27-.84-.38 0 0-.23.06-.45.06-.23 0-.34-.1-.37-.22-.03-.1.03-.29.03-.29l-.34-.05" />
			<path
				d="M277.06 234.85l-.06-.43s.77 0 1.13.26c.57.4.93 1.02.9 1.05-.09.1-.53-.27-.84-.38 0 0-.23.06-.45.06-.23 0-.34-.1-.37-.22-.03-.1.03-.29.03-.29l-.34-.05z"
				fill="none"
				stroke="#000"
				strokeWidth={0.05}
			/>
			<path
				d="M282.57 240.9s-.34-.49-.42-.65c-.09-.15-.23-.48-.23-.48"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M261.88 236.08s.48.34.85.4c.37.05.76.05.82.05.06 0 .17-.54.11-.9a1.84 1.84 0 00-1.3-1.48s.33.73.17 1.07c-.23.48-.65.86-.65.86"
				fill="#db4446"
			/>
			<path
				d="M261.88 236.08s.48.34.85.4c.37.05.76.05.82.05.06 0 .17-.54.11-.9a1.84 1.84 0 00-1.3-1.48s.33.73.17 1.07c-.23.48-.65.86-.65.86z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M259.59 237.12s-.42-.77-1.33-.67c-.9.1-1.5.8-1.5.8s1-.02 1.25.14c.37.24.48.86.48.86s.54-.32.7-.54c.17-.21.4-.59.4-.59"
				fill="#db4446"
			/>
			<path
				d="M259.59 237.12s-.42-.77-1.33-.67c-.9.1-1.5.8-1.5.8s1-.02 1.25.14c.37.24.48.86.48.86s.54-.32.7-.54c.17-.21.4-.59.4-.59z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M258.49 240.25s-.76.11-1.19.6c-.43.48-.37 1.39-.37 1.39s.51-.54.96-.54c.46 0 1.16.16 1.16.16s-.22-.56-.22-.8-.34-.8-.34-.8"
				fill="#db4446"
			/>
			<path
				d="M258.49 240.25s-.76.11-1.19.6c-.43.48-.37 1.39-.37 1.39s.51-.54.96-.54c.46 0 1.16.16 1.16.16s-.22-.56-.22-.8-.34-.8-.34-.8z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path d="M273.08 240.15l.33-.54.34.49-.67.05" />
			<path
				d="M273.08 240.15l.33-.54.34.49-.67.05"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path d="M273.9 240.12l.39-.53.42.48-.82.05" />
			<path
				d="M273.9 240.12l.39-.53.42.48-.82.05"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path d="M273.53 236.83l.82.3-.74.37-.08-.67" />
			<path
				d="M273.53 236.83l.82.3-.74.37-.08-.67"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path d="M274.51 237.1l.74.18-.6.46-.13-.64" />
			<path
				d="M274.51 237.1l.74.18-.6.46-.13-.64"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M269 243.39s-.8.23-1.1.67c-.37.53-.34 1.07-.34 1.07s.68-.56 1.56-.33c.87.24.96.33 1.33.3.37-.03 1.27-.35 1.27-.35s-.74.86-.65 1.45c.08.59.2.85.17 1.15-.06.72-.6 1.6-.6 1.6s.31-.18 1.05-.34a4.77 4.77 0 001.75-.8c.4-.3.9-1.03.9-1.03s-.16 1 0 1.43c.17.42.23 1.66.23 1.66s.47-.42.85-.62c.2-.11.7-.38.9-.7.14-.22.31-1.06.31-1.06s.12.9.4 1.34c.28.42.7 1.74.7 1.74s.29-.86.6-1.21c.3-.35.68-.8.7-1.07.03-.27-.08-.85-.08-.85l.4.85m-11.42.61s.48-.83.93-1.1c.46-.27 1.08-.75 1.25-.8.16-.05.9-.46.9-.46m.99 5.17s1.09-.55 1.41-.75a4.11 4.11 0 001.16-1.12"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M261.06 250.37s-.43-.45-1.16-.32c-.73.14-1.21.97-1.21.97s.62-.17.99-.08c.36.08.62.45.62.45s.33-.3.45-.45c.11-.16.3-.57.3-.57"
				fill="#db4446"
			/>
			<path
				d="M261.06 250.37s-.43-.45-1.16-.32c-.73.14-1.21.97-1.21.97s.62-.17.99-.08c.36.08.62.45.62.45s.33-.3.45-.45c.11-.16.3-.57.3-.57z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M260.21 253.34s-.62-.1-1.16.33c-.53.43-.56 1.25-.56 1.25s.5-.43.9-.37c.4.05.88.27.88.27l.11-.64c.09-.38-.17-.84-.17-.84"
				fill="#db4446"
			/>
			<path
				d="M260.21 253.34s-.62-.1-1.16.33c-.53.43-.56 1.25-.56 1.25s.5-.43.9-.37c.4.05.88.27.88.27l.11-.64c.09-.38-.17-.84-.17-.84z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M261.65 256.08s-.04.8.34 1.28c.4.51 1.13.59 1.13.59s-.24-.53-.28-.8c-.06-.4.34-.75.34-.75s-.37-.38-.73-.38c-.37 0-.8.06-.8.06"
				fill="#db4446"
			/>
			<path
				d="M261.65 256.08s-.04.8.34 1.28c.4.51 1.13.59 1.13.59s-.24-.53-.28-.8c-.06-.4.34-.75.34-.75s-.37-.38-.73-.38c-.37 0-.8.06-.8.06zm16.68 1.33s2.04 1.26 1.98 2.3c-.06 1.05-1.13 2.42-1.13 2.42"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M269 263.12s-.5-.64-1.21-.62c-.71.03-1.45.7-1.45.7s.88-.08 1.1.21c.24.3.46.67.46.67s.4-.21.57-.35c.17-.13.53-.61.53-.61"
				fill="#db4446"
			/>
			<path
				d="M269 263.12s-.5-.64-1.21-.62c-.71.03-1.45.7-1.45.7s.88-.08 1.1.21c.24.3.46.67.46.67s.4-.21.57-.35c.17-.13.53-.61.53-.61z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M266.83 265.93s-.93-.14-1.39.35c-.45.48-.42 1.36-.42 1.36s.56-.61 1.07-.56c.51.05 1.08.32 1.08.32s-.09-.53-.15-.78c-.05-.24-.2-.7-.2-.7"
				fill="#db4446"
			/>
			<path
				d="M266.83 265.93s-.93-.14-1.39.35c-.45.48-.42 1.36-.42 1.36s.56-.61 1.07-.56c.51.05 1.08.32 1.08.32s-.09-.53-.15-.78c-.05-.24-.2-.7-.2-.7z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M268.83 268.9s-.45.64-.1 1.15a2.3 2.3 0 001.04.75s-.26-.37-.14-.8c.09-.34.68-.8.68-.8l-1.48-.3"
				fill="#db4446"
			/>
			<path
				d="M268.83 268.9s-.45.64-.1 1.15a2.3 2.3 0 001.04.75s-.26-.37-.14-.8c.09-.34.68-.8.68-.8l-1.48-.3z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M281.24 270.1s-.81-.18-1.27.09c-.45.26-.82 1.39-.82 1.39s.74-.62 1.28-.54c.53.08.93.3.93.3s.08-.46.02-.78c-.03-.19-.14-.45-.14-.45"
				fill="#db4446"
			/>
			<path
				d="M281.24 270.1s-.81-.18-1.27.09c-.45.26-.82 1.39-.82 1.39s.74-.62 1.28-.54c.53.08.93.3.93.3s.08-.46.02-.78c-.03-.19-.14-.45-.14-.45z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M281.64 273.1s-.62.64-.4 1.18c.23.54.63 1.1.63 1.1s-.03-.8.22-1.02c.37-.32 1.05-.37 1.05-.37s-.54-.48-.71-.54c-.17-.05-.79-.35-.79-.35"
				fill="#db4446"
			/>
			<path
				d="M281.64 273.1s-.62.64-.4 1.18c.23.54.63 1.1.63 1.1s-.03-.8.22-1.02c.37-.32 1.05-.37 1.05-.37s-.54-.48-.71-.54c-.17-.05-.79-.35-.79-.35z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M284.75 274.04s-.31.78.28 1.28c.6.51 1.1.57 1.1.57s-.45-.8-.3-1.23c.14-.45.53-.73.53-.73s-.74-.24-.85-.21c-.1.02-.76.32-.76.32"
				fill="#db4446"
			/>
			<path
				d="M284.75 274.04s-.31.78.28 1.28c.6.51 1.1.57 1.1.57s-.45-.8-.3-1.23c.14-.45.53-.73.53-.73s-.74-.24-.85-.21c-.1.02-.76.32-.76.32z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M252.9 329.55c2.1.63 3.16 2.19 3.16 4.01 0 2.38-2.3 4.18-5.3 4.18-2.99 0-5.41-1.8-5.41-4.18 0-1.8 1-3.8 3.07-3.94 0 0-.06-.2-.24-.5l-.64-.66s.8-.15 1.25.02c.46.18.77.47.77.47s.21-.43.52-.76c.3-.33.7-.53.7-.53s.46.38.61.64c.15.27.25.59.25.59s.42-.35.8-.5c.36-.14.83-.25.83-.25s-.13.46-.22.69c-.1.23-.14.72-.14.72"
				fill="#ffd691"
				stroke="#000"
				strokeWidth={0.52}
			/>
			<path
				d="M250.32 340.32s-3.98-2.68-5.7-3.04c-2.2-.47-4.69-.1-5.76-.15.03.03 1.29.93 1.84 1.48.55.55 2.39 1.65 3.43 1.91 3.22.81 6.2-.2 6.2-.2m1.13.24s2.54-2.66 5.21-3.02c3.15-.44 5.22.26 6.44.58.03 0-1.01.5-1.56.87-.55.38-1.97 1.56-4.14 1.59-2.18.03-4.58-.23-4.98-.17l-.97.14"
				fill="#058e6e"
				stroke="#000"
				strokeWidth={0.52}
			/>
			<path
				d="M250.7 337.28a5.05 5.05 0 010-7.43 5.05 5.05 0 010 7.43"
				fill="#ad1519"
				stroke="#000"
				strokeWidth={0.52}
			/>
			<path
				d="M249.68 342.71s.61-1.52.67-2.83c.06-1.09-.15-2.17-.15-2.17h.8s.4 1.16.4 2.17c0 1.02-.2 2.37-.2 2.37s-.54.08-.72.17c-.19.09-.8.29-.8.29"
				fill="#058e6e"
				stroke="#000"
				strokeWidth={0.52}
			/>
			<path
				d="M300 198.67c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04"
				fill="#fff"
			/>
			<path
				d="M300 198.67c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M301.5 196.02c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04"
				fill="#fff"
			/>
			<path
				d="M301.5 196.02c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M302.5 192.94c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04"
				fill="#fff"
			/>
			<path
				d="M302.5 192.94c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M302.63 189.64c0-.57.49-1.03 1.1-1.03.6 0 1.09.46 1.09 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.09-.46-1.09-1.04"
				fill="#fff"
			/>
			<path
				d="M302.63 189.64c0-.57.49-1.03 1.1-1.03.6 0 1.09.46 1.09 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.09-.46-1.09-1.04z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M301.82 186.4c0-.58.49-1.04 1.09-1.04.6 0 1.1.46 1.1 1.03 0 .58-.5 1.05-1.1 1.05-.6 0-1.1-.47-1.1-1.04"
				fill="#fff"
			/>
			<path
				d="M301.82 186.4c0-.58.49-1.04 1.09-1.04.6 0 1.1.46 1.1 1.03 0 .58-.5 1.05-1.1 1.05-.6 0-1.1-.47-1.1-1.04z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M300.13 183.45c0-.58.49-1.04 1.1-1.04.6 0 1.1.46 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.61 0-1.1-.47-1.1-1.04"
				fill="#fff"
			/>
			<path
				d="M300.13 183.45c0-.58.49-1.04 1.1-1.04.6 0 1.1.46 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.61 0-1.1-.47-1.1-1.04z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M297.88 181.03c0-.58.49-1.04 1.1-1.04.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.61 0-1.1-.46-1.1-1.03"
				fill="#fff"
			/>
			<path
				d="M297.88 181.03c0-.58.49-1.04 1.1-1.04.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.61 0-1.1-.46-1.1-1.03z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M295.26 179.01c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04"
				fill="#fff"
			/>
			<path
				d="M295.26 179.01c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M292.14 177.36c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04"
				fill="#fff"
			/>
			<path
				d="M292.14 177.36c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M288.9 176.19c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04"
				fill="#fff"
			/>
			<path
				d="M288.9 176.19c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M285.28 175.54c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04"
				fill="#fff"
			/>
			<path
				d="M285.28 175.54c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M281.84 175.36c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04"
				fill="#fff"
			/>
			<path
				d="M281.84 175.36c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M278.47 175.48c0-.57.49-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.61 0-1.1-.47-1.1-1.04"
				fill="#fff"
			/>
			<path
				d="M278.47 175.48c0-.57.49-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.61 0-1.1-.47-1.1-1.04z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M275.1 175.48c0-.57.49-1.04 1.1-1.04.6 0 1.09.47 1.09 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04"
				fill="#fff"
			/>
			<path
				d="M275.1 175.48c0-.57.49-1.04 1.1-1.04.6 0 1.09.47 1.09 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M276.79 178.37c0-.57.49-1.04 1.09-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04m.69 3.2c0-.58.5-1.04 1.1-1.04.6 0 1.1.46 1.1 1.04 0 .57-.5 1.03-1.1 1.03-.6 0-1.1-.46-1.1-1.03m.13 3.18c0-.57.49-1.04 1.1-1.04.6 0 1.09.47 1.09 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04m-.99 2.9c0-.57.49-1.04 1.1-1.04.6 0 1.09.47 1.09 1.04 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04m-1.86 2.66c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.03"
				fill="#fff"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M272.54 173.47c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04"
				fill="#fff"
			/>
			<path
				d="M272.54 173.47c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M269.55 171.81c0-.57.49-1.04 1.1-1.04.6 0 1.09.47 1.09 1.04 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04"
				fill="#fff"
			/>
			<path
				d="M269.55 171.81c0-.57.49-1.04 1.1-1.04.6 0 1.09.47 1.09 1.04 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M266.25 170.82c0-.58.49-1.04 1.1-1.04.6 0 1.09.46 1.09 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04"
				fill="#fff"
			/>
			<path
				d="M266.25 170.82c0-.58.49-1.04 1.1-1.04.6 0 1.09.46 1.09 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M262.81 170.23c0-.57.5-1.04 1.1-1.04.6 0 1.09.47 1.09 1.04 0 .57-.49 1.03-1.1 1.03-.6 0-1.09-.46-1.09-1.03"
				fill="#fff"
			/>
			<path
				d="M262.81 170.23c0-.57.5-1.04 1.1-1.04.6 0 1.09.47 1.09 1.04 0 .57-.49 1.03-1.1 1.03-.6 0-1.09-.46-1.09-1.03z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M259.45 170.28c0-.57.49-1.04 1.1-1.04.6 0 1.09.47 1.09 1.04 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04"
				fill="#fff"
			/>
			<path
				d="M259.45 170.28c0-.57.49-1.04 1.1-1.04.6 0 1.09.47 1.09 1.04 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M255.95 170.87c0-.57.49-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.61 0-1.1-.46-1.1-1.04"
				fill="#fff"
			/>
			<path
				d="M255.95 170.87c0-.57.49-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.61 0-1.1-.46-1.1-1.04z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M252.7 172c0-.58.5-1.05 1.1-1.05.61 0 1.1.47 1.1 1.04 0 .57-.49 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04"
				fill="#fff"
			/>
			<path
				d="M252.7 172c0-.58.5-1.05 1.1-1.05.61 0 1.1.47 1.1 1.04 0 .57-.49 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M197.84 198.67c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04"
				fill="#fff"
			/>
			<path
				d="M197.84 198.67c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M196.34 196.02c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04"
				fill="#fff"
			/>
			<path
				d="M196.34 196.02c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M195.34 192.94c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04"
				fill="#fff"
			/>
			<path
				d="M195.34 192.94c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M195.22 189.64c0-.57.49-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.61 0-1.1-.46-1.1-1.04"
				fill="#fff"
			/>
			<path
				d="M195.22 189.64c0-.57.49-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.61 0-1.1-.46-1.1-1.04z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M196.03 186.4c0-.58.5-1.04 1.1-1.04.6 0 1.1.46 1.1 1.03 0 .58-.5 1.05-1.1 1.05-.6 0-1.1-.47-1.1-1.04"
				fill="#fff"
			/>
			<path
				d="M196.03 186.4c0-.58.5-1.04 1.1-1.04.6 0 1.1.46 1.1 1.03 0 .58-.5 1.05-1.1 1.05-.6 0-1.1-.47-1.1-1.04z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M197.71 183.45c0-.58.5-1.04 1.1-1.04.6 0 1.1.46 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04"
				fill="#fff"
			/>
			<path
				d="M197.71 183.45c0-.58.5-1.04 1.1-1.04.6 0 1.1.46 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M199.97 181.03c0-.58.49-1.04 1.1-1.04.6 0 1.09.46 1.09 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.03"
				fill="#fff"
			/>
			<path
				d="M199.97 181.03c0-.58.49-1.04 1.1-1.04.6 0 1.09.46 1.09 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.03z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M202.58 179.01c0-.57.49-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.61 0-1.1-.47-1.1-1.04"
				fill="#fff"
			/>
			<path
				d="M202.58 179.01c0-.57.49-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.61 0-1.1-.47-1.1-1.04z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M205.7 177.36c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04"
				fill="#fff"
			/>
			<path
				d="M205.7 177.36c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M208.94 176.19c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04"
				fill="#fff"
			/>
			<path
				d="M208.94 176.19c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M212.57 175.54c0-.57.49-1.04 1.1-1.04.6 0 1.09.47 1.09 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04"
				fill="#fff"
			/>
			<path
				d="M212.57 175.54c0-.57.49-1.04 1.1-1.04.6 0 1.09.47 1.09 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M216 175.36c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04"
				fill="#fff"
			/>
			<path
				d="M216 175.36c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M219.38 175.48c0-.57.49-1.04 1.09-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04"
				fill="#fff"
			/>
			<path
				d="M219.38 175.48c0-.57.49-1.04 1.09-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M222.75 175.48c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04"
				fill="#fff"
			/>
			<path
				d="M222.75 175.48c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M221.06 178.37c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04m-.68 3.2c0-.58.48-1.04 1.1-1.04.6 0 1.09.46 1.09 1.04 0 .57-.5 1.03-1.1 1.03-.6 0-1.1-.46-1.1-1.03m-.12 3.18c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04m1 2.9c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04m1.86 2.66c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.03"
				fill="#fff"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M225.3 173.47c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04"
				fill="#fff"
			/>
			<path
				d="M225.3 173.47c0-.57.5-1.03 1.1-1.03.6 0 1.1.46 1.1 1.03 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M228.3 171.81c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04"
				fill="#fff"
			/>
			<path
				d="M228.3 171.81c0-.57.5-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M231.6 170.82c0-.58.5-1.04 1.1-1.04.6 0 1.1.46 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04"
				fill="#fff"
			/>
			<path
				d="M231.6 170.82c0-.58.5-1.04 1.1-1.04.6 0 1.1.46 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M235.04 170.23c0-.57.49-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.03-1.1 1.03-.61 0-1.1-.46-1.1-1.03"
				fill="#fff"
			/>
			<path
				d="M235.04 170.23c0-.57.49-1.04 1.1-1.04.6 0 1.1.47 1.1 1.04 0 .57-.5 1.03-1.1 1.03-.61 0-1.1-.46-1.1-1.03z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M238.4 170.28c0-.57.49-1.04 1.1-1.04.6 0 1.09.47 1.09 1.04 0 .58-.5 1.04-1.1 1.04-.6 0-1.09-.46-1.09-1.04"
				fill="#fff"
			/>
			<path
				d="M238.4 170.28c0-.57.49-1.04 1.1-1.04.6 0 1.09.47 1.09 1.04 0 .58-.5 1.04-1.1 1.04-.6 0-1.09-.46-1.09-1.04z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M241.9 170.87c0-.57.49-1.03 1.1-1.03.6 0 1.09.46 1.09 1.03 0 .58-.49 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04"
				fill="#fff"
			/>
			<path
				d="M241.9 170.87c0-.57.49-1.03 1.1-1.03.6 0 1.09.46 1.09 1.03 0 .58-.49 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M245.13 172c0-.58.5-1.05 1.1-1.05.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04"
				fill="#fff"
			/>
			<path
				d="M245.13 172c0-.58.5-1.05 1.1-1.05.6 0 1.1.47 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04z"
				fill="none"
				stroke="#000"
				strokeWidth={0.39}
			/>
			<path
				d="M217.34 238.41h-.92v-.92h-1.62v3.7h1.62v2.54h-3.47v7.4h1.85v14.78h-3.7v7.63h28.42v-7.63h-3.7v-14.79h1.86v-7.4h-3.47v-2.53h1.62v-3.7h-1.62v.92h-.93v-.92h-1.61v.92h-1.16v-.92h-1.62v3.7h1.62v2.54h-3.46v-8.1h1.84v-3.69h-1.84v.93h-.93v-.93h-1.62v.93h-.92v-.93h-1.85v3.7h1.85v8.09h-3.47v-2.54h1.62v-3.7h-1.62v.92h-.92v-.92h-1.85v.92zm-6.24 35.13h28.42m-28.42-1.85h28.42m-28.42-1.85h28.42m-28.42-1.85h28.42m-28.42-2.08h28.42m-24.72-1.62h21.03m-21.03-1.85h21.03m-21.03-2.08h21.03m-21.03-1.85h21.03m-21.03-1.84h21.03m-21.03-1.85h21.03m-21.03-1.85h21.03m-22.88-1.85h24.73m-24.73-1.85h24.73m-24.73-1.85h24.73m-24.73-1.84h24.73m-21.26-1.85h17.79m-10.63-1.85h3.47m-3.47-1.85h3.47m-3.47-1.85h3.47m-3.47-1.85h3.47m-5.32-2.3h7.16m-12.47 7.85h3.7m-5.32-2.31h6.93m-6.93 33.97v-1.85m0-1.85v-1.85m-1.85 1.85v1.85m3.47 0v-1.85m1.84 3.7v-1.85m0-1.85v-1.85m0-2.08v-1.62m0-1.85v-2.08m-1.84 7.63v-2.08m-3.47 2.08v-2.08m7.16 0v2.08m1.62-2.08v-1.62m-5.31-1.85v1.85m3.7-1.85v1.85m3.46-1.85v1.85m-1.85-1.85v-2.08m1.85-1.85v1.85m0-5.54v1.85m-1.85-3.7v1.85m1.85-3.7v1.85m-3.47-1.85v1.85m-3.7-1.85v1.85m-1.61-3.7v1.85m3.46-1.85v1.85m3.47-1.85v1.85m1.85-3.7v1.85m-3.47-1.85v1.85m-3.7-1.85v1.85m-1.61-3.7v1.85m6.93-1.84v1.84m-3.47-5.54v1.85m15.95-1.85h-3.7m5.32-2.31h-6.94m6.94 33.97v-1.85m0-1.85v-1.85m1.84 1.85v1.85m-3.46 0v-1.85m-1.85 3.7v-1.85m0-1.85v-1.85m0-2.08v-1.62m0-1.85v-2.08m1.85 7.63v-2.08m3.47 2.08v-2.08m-7.17 0v2.08m-1.62-2.08v-1.62m5.32-1.85v1.85m-3.7-1.85v1.85m-3.46-1.85v1.85m1.84-1.85v-2.08m-1.84-1.85v1.85m0-5.54v1.85m1.84-3.7v1.85m-1.84-3.7v1.85m3.46-1.85v1.85m3.7-1.85v1.85m1.62-3.7v1.85m-3.47-1.85v1.85m-3.47-1.85v1.85m-1.84-3.7v1.85m3.46-1.85v1.85m3.7-1.85v1.85m1.62-3.7v1.85m-6.94-1.84v1.84m3.47-5.54v1.85m-7.16 18.71v-2.08m0-5.54v-1.85m0 5.54v-1.84m0-5.55v-1.85m0-1.85v-1.84m0-3.7v-1.85m0-1.85v-1.85m-8.78 4.85h3.7m3.46-5.54h3.47m3.46 5.55h3.7"
				fill="#c8b100"
				stroke="#000"
				strokeWidth={0.46}
			/>
			<path
				d="M230.05 273.54v-4.86c0-.92-.46-3.7-4.85-3.7-4.16 0-4.62 2.78-4.62 3.7v4.86h9.47z"
				fill="#c8b100"
				stroke="#000"
				strokeWidth={0.46}
			/>
			<path
				d="M222.2 268.91l-2.32-.23c0-.92.23-2.3.93-2.77l2.08 1.62c-.23.23-.7.92-.7 1.38zm6.23 0l2.31-.23c0-.92-.23-2.3-.92-2.77l-2.08 1.62c.23.23.7.92.7 1.38zm-2.31-2.31l1.16-2.08a5.52 5.52 0 00-2.08-.46c-.46 0-1.39.23-1.85.46l1.15 2.08h1.62zm-4.39-5.77v-5.09c0-1.38-.92-2.54-2.54-2.54s-2.54 1.16-2.54 2.54v5.09h5.08zm7.17 0v-5.09c0-1.38.92-2.54 2.54-2.54 1.61 0 2.54 1.16 2.54 2.54v5.09h-5.09zm-1.85-12.48l.46-4.62h-4.4l.24 4.62h3.7zm3.46 0l-.46-4.62h4.62l-.46 4.62h-3.7zm-10.4 0l.23-4.62h-4.39l.47 4.62h3.7z"
				fill="#c8b100"
				stroke="#000"
				strokeWidth={0.46}
			/>
			<path
				d="M228.43 273.54v-4.17c0-.69-.46-2.77-3.23-2.77a2.8 2.8 0 00-3 2.77v4.17h6.23zm-7.16-13.18v-4.39c0-1.15-.7-2.3-2.08-2.3-1.39 0-2.08 1.15-2.08 2.3v4.4h4.16zm8.09 0v-4.39c0-1.15.69-2.3 2.08-2.3 1.38 0 2.08 1.15 2.08 2.3v4.4h-4.16z"
				fill="#0039f0"
			/>
			<path
				d="M234.18 281c0-10.1 7.27-18.29 16.25-18.29s16.26 8.2 16.26 18.3c0 10.1-7.28 18.29-16.26 18.29s-16.25-8.2-16.25-18.3"
				fill="#ad1519"
			/>
			<path
				d="M234.18 281c0-10.1 7.27-18.29 16.25-18.29s16.26 8.2 16.26 18.3c0 10.1-7.28 18.29-16.26 18.29s-16.25-8.2-16.25-18.3z"
				fill="none"
				stroke="#000"
				strokeWidth={0.61}
			/>
			<path
				d="M239 280.97c0-7.4 5.12-13.41 11.44-13.41 6.31 0 11.43 6 11.43 13.41s-5.12 13.42-11.43 13.42c-6.32 0-11.44-6-11.44-13.42"
				fill="#005bbf"
			/>
			<path
				d="M239 280.97c0-7.4 5.12-13.41 11.44-13.41 6.31 0 11.43 6 11.43 13.41s-5.12 13.42-11.43 13.42c-6.32 0-11.44-6-11.44-13.42z"
				fill="none"
				stroke="#000"
				strokeWidth={0.61}
			/>
			<path
				d="M245.03 271.74s-1.35 1.49-1.35 2.86c0 1.39.57 2.54.57 2.54a1.5 1.5 0 00-1.41-.94c-.83 0-1.5.63-1.5 1.42 0 .22.14.58.24.77l.5.99c.15-.37.53-.57.97-.57.6 0 1.08.45 1.08 1.01 0 .09-.01.17-.04.25h-1.22v1.04h1.1l-.82 1.6 1.07-.41.81.91.84-.91 1.07.42-.8-1.6h1.08v-1.05H246a1.04 1.04 0 011.04-1.26c.44 0 .82.2.99.57l.48-.99c.1-.2.24-.55.24-.77 0-.79-.66-1.42-1.5-1.42-.65 0-1.2.4-1.4.94 0 0 .57-1.15.57-2.54 0-1.38-1.39-2.86-1.39-2.86"
				fill="#c8b100"
			/>
			<path
				d="M245.03 271.74s-1.35 1.49-1.35 2.86c0 1.39.57 2.54.57 2.54a1.5 1.5 0 00-1.41-.94c-.83 0-1.5.63-1.5 1.42 0 .22.14.58.24.77l.5.99c.15-.37.53-.57.97-.57.6 0 1.08.45 1.08 1.01 0 .09-.01.17-.04.25h-1.22v1.04h1.1l-.82 1.6 1.07-.41.81.91.84-.91 1.07.42-.8-1.6h1.08v-1.05H246a1.04 1.04 0 011.04-1.26c.44 0 .82.2.99.57l.48-.99c.1-.2.24-.55.24-.77 0-.79-.66-1.42-1.5-1.42-.65 0-1.2.4-1.4.94 0 0 .57-1.15.57-2.54 0-1.38-1.39-2.86-1.39-2.86z"
				fill="none"
				stroke="#000"
				strokeLinejoin="round"
				strokeWidth={0.34}
			/>
			<path d="M242.87 281.11h4.36v-1.04h-4.36v1.04z" fill="#c8b100" />
			<path
				d="M242.87 281.11h4.36v-1.04h-4.36v1.04z"
				fill="none"
				stroke="#000"
				strokeWidth={0.34}
			/>
			<path
				d="M255.66 271.74s-1.35 1.49-1.35 2.86c0 1.39.57 2.54.57 2.54a1.5 1.5 0 00-1.41-.94c-.83 0-1.5.63-1.5 1.42 0 .22.14.58.24.77l.49.99c.16-.37.54-.57.98-.57.6 0 1.07.45 1.07 1.01 0 .09 0 .17-.03.25h-1.22v1.04h1.1l-.82 1.6 1.07-.41.81.91.84-.91 1.07.42-.8-1.6h1.08v-1.05h-1.22a.88.88 0 01-.03-.25c0-.56.48-1 1.07-1 .44 0 .82.2.98.56l.49-.99c.1-.2.24-.55.24-.77 0-.79-.67-1.42-1.5-1.42-.64 0-1.2.4-1.4.94 0 0 .57-1.15.57-2.54 0-1.38-1.39-2.86-1.39-2.86"
				fill="#c8b100"
			/>
			<path
				d="M255.66 271.74s-1.35 1.49-1.35 2.86c0 1.39.57 2.54.57 2.54a1.5 1.5 0 00-1.41-.94c-.83 0-1.5.63-1.5 1.42 0 .22.14.58.24.77l.49.99c.16-.37.54-.57.98-.57.6 0 1.07.45 1.07 1.01 0 .09 0 .17-.03.25h-1.22v1.04h1.1l-.82 1.6 1.07-.41.81.91.84-.91 1.07.42-.8-1.6h1.08v-1.05h-1.22a.88.88 0 01-.03-.25c0-.56.48-1 1.07-1 .44 0 .82.2.98.56l.49-.99c.1-.2.24-.55.24-.77 0-.79-.67-1.42-1.5-1.42-.64 0-1.2.4-1.4.94 0 0 .57-1.15.57-2.54 0-1.38-1.39-2.86-1.39-2.86z"
				fill="none"
				stroke="#000"
				strokeLinejoin="round"
				strokeWidth={0.34}
			/>
			<path d="M253.5 281.11h4.35v-1.04h-4.35v1.04z" fill="#c8b100" />
			<path
				d="M253.5 281.11h4.35v-1.04h-4.35v1.04z"
				fill="none"
				stroke="#000"
				strokeWidth={0.34}
			/>
			<path
				d="M250.35 280.88s-1.36 1.49-1.36 2.87c0 1.38.57 2.53.57 2.53a1.5 1.5 0 00-1.41-.94c-.83 0-1.5.63-1.5 1.42 0 .23.14.58.25.78l.48.98c.17-.36.54-.57.99-.57.59 0 1.07.45 1.07 1.02a.9.9 0 01-.03.25h-1.22v1.04h1.09l-.81 1.6 1.07-.42.8.91.85-.9 1.07.41-.81-1.6h1.09v-1.04h-1.22a.94.94 0 01-.03-.25c0-.57.47-1.02 1.07-1.02.44 0 .81.2.98.57l.49-.98c.1-.2.24-.55.24-.78 0-.79-.67-1.42-1.5-1.42-.65 0-1.2.4-1.41.94 0 0 .57-1.15.57-2.53s-1.39-2.87-1.39-2.87"
				fill="#c8b100"
			/>
			<path
				d="M250.35 280.88s-1.36 1.49-1.36 2.87c0 1.38.57 2.53.57 2.53a1.5 1.5 0 00-1.41-.94c-.83 0-1.5.63-1.5 1.42 0 .23.14.58.25.78l.48.98c.17-.36.54-.57.99-.57.59 0 1.07.45 1.07 1.02a.9.9 0 01-.03.25h-1.22v1.04h1.09l-.81 1.6 1.07-.42.8.91.85-.9 1.07.41-.81-1.6h1.09v-1.04h-1.22a.94.94 0 01-.03-.25c0-.57.47-1.02 1.07-1.02.44 0 .81.2.98.57l.49-.98c.1-.2.24-.55.24-.78 0-.79-.67-1.42-1.5-1.42-.65 0-1.2.4-1.41.94 0 0 .57-1.15.57-2.53s-1.39-2.87-1.39-2.87z"
				fill="none"
				stroke="#000"
				strokeLinejoin="round"
				strokeWidth={0.34}
			/>
			<path d="M248.19 290.26h4.35v-1.04h-4.35v1.04z" fill="#c8b100" />
			<path
				d="M248.19 290.26h4.35v-1.04h-4.35v1.04z"
				fill="none"
				stroke="#000"
				strokeWidth={0.34}
			/>
			<path
				d="M282.88 232.7l-.29.03c-.01.03-.14.24-.26.35-.26.25-.64.27-.86.07a.5.5 0 01-.14-.4.52.52 0 01-.51-.02c-.26-.14-.32-.5-.14-.8.03-.05.06-.13.1-.17l-.01-.32-.35.08-.1.2c-.22.24-.54.3-.7.16a.58.58 0 01-.13-.27c0 .01-.09.09-.18.1-.53.14-.74-1.04-.76-1.34l-.17.25s.16.7.08 1.3c-.08.6-.3 1.2-.3 1.2.75.18 1.87.79 2.98 1.64a9.39 9.39 0 012.35 2.42s.57-.32 1.17-.5c.6-.2 1.36-.2 1.36-.2l.22-.22c-.32.05-1.59.1-1.56-.43 0-.08.07-.18.08-.18 0 .01-.21 0-.3-.06-.18-.13-.18-.43.02-.69l.18-.13.01-.34-.34.05c-.03.04-.1.09-.15.13-.27.23-.65.25-.86.03a.44.44 0 01-.11-.46.57.57 0 01-.45-.05c-.26-.15-.31-.52-.11-.8.1-.14.28-.3.3-.32l-.06-.3"
				fill="#c8b100"
			/>
			<path
				d="M282.88 232.7l-.29.03c-.01.03-.14.24-.26.35-.26.25-.64.27-.86.07a.5.5 0 01-.14-.4.52.52 0 01-.51-.02c-.26-.14-.32-.5-.14-.8.03-.05.06-.13.1-.17l-.01-.32-.35.08-.1.2c-.22.24-.54.3-.7.16a.58.58 0 01-.13-.27c0 .01-.09.09-.18.1-.53.14-.74-1.04-.76-1.34l-.17.25s.16.7.08 1.3c-.08.6-.3 1.2-.3 1.2.75.18 1.87.79 2.98 1.64a9.39 9.39 0 012.35 2.42s.57-.32 1.17-.5c.6-.2 1.36-.2 1.36-.2l.22-.22c-.32.05-1.59.1-1.56-.43 0-.08.07-.18.08-.18 0 .01-.21 0-.3-.06-.18-.13-.18-.43.02-.69l.18-.13.01-.34-.34.05c-.03.04-.1.09-.15.13-.27.23-.65.25-.86.03a.44.44 0 01-.11-.46.57.57 0 01-.45-.05c-.26-.15-.31-.52-.11-.8.1-.14.28-.3.3-.32l-.06-.3z"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path d="M280.63 233.4c.05-.07.16-.06.23 0 .08.06.1.16.06.21-.05.06-.15.06-.24 0-.07-.06-.1-.16-.05-.22" />
			<path
				d="M280.63 233.4c.05-.07.16-.06.23 0 .08.06.1.16.06.21-.05.06-.15.06-.24 0-.07-.06-.1-.16-.05-.22z"
				fill="none"
				stroke="#000"
				strokeWidth={0.05}
			/>
			<path d="M281.58 234.2l-.33-.26c-.06-.04-.07-.12-.04-.16.04-.04.12-.04.18 0l.32.26.34.25c.06.04.08.12.04.16-.04.04-.12.04-.18 0l-.33-.26" />
			<path
				d="M281.58 234.2l-.33-.26c-.06-.04-.07-.12-.04-.16.04-.04.12-.04.18 0l.32.26.34.25c.06.04.08.12.04.16-.04.04-.12.04-.18 0l-.33-.26"
				fill="none"
				stroke="#000"
				strokeWidth={0.05}
			/>
			<path d="M279.84 233l-.26-.15c-.07-.04-.1-.12-.07-.16.03-.06.1-.07.17-.03l.26.16.26.15c.06.03.1.1.07.16-.03.05-.1.06-.17.02l-.26-.15" />
			<path
				d="M279.84 233l-.26-.15c-.07-.04-.1-.12-.07-.16.03-.06.1-.07.17-.03l.26.16.26.15c.06.03.1.1.07.16-.03.05-.1.06-.17.02l-.26-.15"
				fill="none"
				stroke="#000"
				strokeWidth={0.05}
			/>
			<path d="M278.8 232.29c.05-.06.16-.06.24 0 .08.06.1.16.05.22-.05.05-.15.05-.23 0-.08-.07-.1-.16-.06-.22" />
			<path
				d="M278.8 232.29c.05-.06.16-.06.24 0 .08.06.1.16.05.22-.05.05-.15.05-.23 0-.08-.07-.1-.16-.06-.22z"
				fill="none"
				stroke="#000"
				strokeWidth={0.05}
			/>
			<path d="M282.63 234.93c.05-.06.02-.15-.05-.22-.08-.06-.19-.06-.23 0-.05.05-.03.15.05.21s.18.06.23 0" />
			<path
				d="M282.63 234.93c.05-.06.02-.15-.05-.22-.08-.06-.19-.06-.23 0-.05.05-.03.15.05.21s.18.06.23 0z"
				fill="none"
				stroke="#000"
				strokeWidth={0.05}
			/>
			<path d="M283.2 235.58l.22.2c.05.06.13.08.18.04.04-.04.04-.11-.01-.16l-.21-.2-.22-.22c-.05-.05-.14-.07-.18-.03-.05.03-.04.11.01.16l.21.21" />
			<path
				d="M283.2 235.58l.22.2c.05.06.13.08.18.04.04-.04.04-.11-.01-.16l-.21-.2-.22-.22c-.05-.05-.14-.07-.18-.03-.05.03-.04.11.01.16l.21.21"
				fill="none"
				stroke="#000"
				strokeWidth={0.05}
			/>
			<path d="M284.15 236.4c.05-.07.03-.16-.05-.22-.08-.07-.18-.07-.23 0-.05.05-.03.14.05.2s.18.07.23.01" />
			<path
				d="M284.15 236.4c.05-.07.03-.16-.05-.22-.08-.07-.18-.07-.23 0-.05.05-.03.14.05.2s.18.07.23.01z"
				fill="none"
				stroke="#000"
				strokeWidth={0.05}
			/>
			<path d="M281.4 230.35l-.59.02-.11.87.06.14h.15l.76-.52-.27-.5" fill="#c8b100" />
			<path
				d="M281.4 230.35l-.59.02-.11.87.06.14h.15l.76-.52-.27-.5"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path d="M279.8 230.84l-.02.54.92.12.15-.07-.02-.15-.53-.7-.5.26" fill="#c8b100" />
			<path
				d="M279.8 230.84l-.02.54.92.12.15-.07-.02-.15-.53-.7-.5.26"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path d="M281.7 231.92l-.5.27-.53-.71v-.15l.13-.06.93.11-.03.54" fill="#c8b100" />
			<path
				d="M281.7 231.92l-.5.27-.53-.71v-.15l.13-.06.93.11-.03.54"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M280.51 231.25a.3.3 0 01.4-.1c.13.08.17.25.1.38a.3.3 0 01-.4.1.27.27 0 01-.1-.38"
				fill="#c8b100"
			/>
			<path
				d="M280.51 231.25a.3.3 0 01.4-.1c.13.08.17.25.1.38a.3.3 0 01-.4.1.27.27 0 01-.1-.38z"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M278.36 230.35c-.01 0-.13-.46-.26-.71-.08-.19-.39-.43-.39-.43.03-.06.42-.2.87.1.38.3-.03.86-.03.86s-.1.14-.19.18"
				fill="#c8b100"
			/>
			<path
				d="M278.36 230.35c-.01 0-.13-.46-.26-.71-.08-.19-.39-.43-.39-.43.03-.06.42-.2.87.1.38.3-.03.86-.03.86s-.1.14-.19.18z"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path d="M279.4 230.66l-.43.37-.68-.6.06-.08.02-.15.93-.07.1.53" fill="#c8b100" />
			<path
				d="M279.4 230.66l-.43.37-.68-.6.06-.08.02-.15.93-.07.1.53"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M278.24 230.3c.05-.16.18-.24.28-.21.1.04.15.18.1.33-.05.15-.18.23-.29.2-.1-.03-.15-.18-.1-.33"
				fill="#c8b100"
			/>
			<path
				d="M278.24 230.3c.05-.16.18-.24.28-.21.1.04.15.18.1.33-.05.15-.18.23-.29.2-.1-.03-.15-.18-.1-.33z"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path d="M283.67 231.77l-.6-.06-.24.85.05.14h.15l.83-.4-.2-.53" fill="#c8b100" />
			<path
				d="M283.67 231.77l-.6-.06-.24.85.05.14h.15l.83-.4-.2-.53"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path d="M282 232.03l-.09.54.9.24.15-.05v-.14l-.42-.79-.53.2" fill="#c8b100" />
			<path
				d="M282 232.03l-.09.54.9.24.15-.05v-.14l-.42-.79-.53.2"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path d="M283.73 233.35l-.53.22-.42-.79.01-.15.15-.03.9.23-.1.52" fill="#c8b100" />
			<path
				d="M283.73 233.35l-.53.22-.42-.79.01-.15.15-.03.9.23-.1.52"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M282.65 232.54c.1-.12.28-.13.4-.04.13.1.15.26.05.38a.3.3 0 01-.4.04.26.26 0 01-.05-.38"
				fill="#c8b100"
			/>
			<path
				d="M282.65 232.54c.1-.12.28-.13.4-.04.13.1.15.26.05.38a.3.3 0 01-.4.04.26.26 0 01-.05-.38z"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path d="M285.64 233.6l.11.56-.87.3-.15-.03-.02-.15.36-.8.57.13" fill="#c8b100" />
			<path
				d="M285.64 233.6l.11.56-.87.3-.15-.03-.02-.15.36-.8.57.13"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path d="M285.49 235.2l-.56.13-.31-.84.03-.14.16-.02.85.35-.17.52" fill="#c8b100" />
			<path
				d="M285.49 235.2l-.56.13-.31-.84.03-.14.16-.02.85.35-.17.52"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path d="M283.97 233.66l-.18.52.85.34.16-.02.03-.14-.3-.83-.56.13" fill="#c8b100" />
			<path
				d="M283.97 233.66l-.18.52.85.34.16-.02.03-.14-.3-.83-.56.13"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M284.91 234.63c.12-.11.12-.28.02-.4a.31.31 0 00-.41 0 .27.27 0 00-.01.38c.1.11.29.12.4.02"
				fill="#c8b100"
			/>
			<path
				d="M284.91 234.63c.12-.11.12-.28.02-.4a.31.31 0 00-.41 0 .27.27 0 00-.01.38c.1.11.29.12.4.02z"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M286.29 236.43c0 .01.5.03.79.09.2.04.52.27.52.27.06-.04.11-.42-.28-.78-.4-.29-.88.2-.88.2s-.12.13-.15.22"
				fill="#c8b100"
			/>
			<path
				d="M286.29 236.43c0 .01.5.03.79.09.2.04.52.27.52.27.06-.04.11-.42-.28-.78-.4-.29-.88.2-.88.2s-.12.13-.15.22z"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path d="M285.75 235.53l-.29.47.76.51.1-.08.12-.04-.12-.88-.57.03" fill="#c8b100" />
			<path
				d="M285.75 235.53l-.29.47.76.51.1-.08.12-.04-.12-.88-.57.03"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M286.37 236.53c.14-.07.2-.22.15-.3-.06-.1-.22-.1-.36-.03-.14.08-.2.22-.14.31.05.1.21.1.35.02"
				fill="#c8b100"
			/>
			<path
				d="M286.37 236.53c.14-.07.2-.22.15-.3-.06-.1-.22-.1-.36-.03-.14.08-.2.22-.14.31.05.1.21.1.35.02z"
				fill="none"
				stroke="#000"
				strokeWidth={0.26}
			/>
			<path
				d="M326.13 213.64v.58h-2.53v-.58h.94v-1.3h-.62v-.59h.62v-.57h.6v.57h.62v.59h-.61v1.3h.98"
				fill="none"
				stroke="#000"
				strokeWidth={0.3}
			/>
			<path d="M175.44 226.15v-1.27" fill="none" stroke="#000" strokeWidth={0.02} />
			<path d="M175.1 226.15v-1.27" fill="none" stroke="#000" strokeWidth={0.03} />
			<path
				d="M174.77 226.15v-1.27m-.33 1.27v-1.27"
				fill="none"
				stroke="#000"
				strokeWidth={0.04}
			/>
			<path d="M174.16 226.15v-1.27" fill="none" stroke="#000" strokeWidth={0.05} />
			<path
				d="M173.6 226.08v-1.15m.27 1.17v-1.21"
				fill="none"
				stroke="#000"
				strokeWidth={0.06}
			/>
			<path
				d="M173.1 226.03v-1.06m.26 1.09v-1.13"
				fill="none"
				stroke="#000"
				strokeWidth={0.07}
			/>
			<path
				d="M172.43 225.97v-.94m.22.95v-.97m.23 1V225"
				fill="none"
				stroke="#000"
				strokeWidth={0.08}
			/>
			<path d="M172.19 225.96v-.9" fill="none" stroke="#000" strokeWidth={0.09} />
			<path d="M171.97 225.92v-.85" fill="none" stroke="#000" strokeWidth={0.1} />
			<path d="M171.73 225.9v-.79" fill="none" stroke="#000" strokeWidth={0.11} />
			<path
				d="M171.24 225.82v-.62m.25.66v-.7m-.49.61v-.55"
				fill="none"
				stroke="#000"
				strokeWidth={0.12}
			/>
			<path d="M170.76 225.73v-.46" fill="none" stroke="#000" strokeWidth={0.13} />
			<path d="M170.51 225.67v-.36" fill="none" stroke="#000" strokeWidth={0.14} />
			<path d="M170.26 225.64v-.27" fill="none" stroke="#000" strokeWidth={0.15} />
			<path d="M169.99 225.58v-.13" fill="none" stroke="#000" strokeWidth={0.18} />
			<path
				d="M176.8 226.08v-1.16m-.58 1.2v-1.23m-.42 1.25v-1.26"
				fill="none"
				stroke="#000"
				strokeWidth={0.01}
			/>
			<path d="M324.77 226.17v-1.27" fill="none" stroke="#000" strokeWidth={0.02} />
			<path d="M324.42 226.17v-1.27" fill="none" stroke="#000" strokeWidth={0.03} />
			<path
				d="M324.1 226.17v-1.27m-.32 1.27v-1.27"
				fill="none"
				stroke="#000"
				strokeWidth={0.04}
			/>
			<path d="M323.49 226.17v-1.27" fill="none" stroke="#000" strokeWidth={0.05} />
			<path
				d="M322.94 226.1v-1.15m.26 1.17v-1.2"
				fill="none"
				stroke="#000"
				strokeWidth={0.06}
			/>
			<path
				d="M322.44 226.05V225m.25 1.1v-1.14"
				fill="none"
				stroke="#000"
				strokeWidth={0.07}
			/>
			<path
				d="M321.76 226v-.94m.22.95v-.98m.23 1v-1.01"
				fill="none"
				stroke="#000"
				strokeWidth={0.08}
			/>
			<path d="M321.52 225.98v-.9" fill="none" stroke="#000" strokeWidth={0.09} />
			<path d="M321.3 225.94v-.84" fill="none" stroke="#000" strokeWidth={0.1} />
			<path d="M321.06 225.91v-.78" fill="none" stroke="#000" strokeWidth={0.11} />
			<path
				d="M320.57 225.85v-.63m.25.66v-.7m-.5.62v-.55"
				fill="none"
				stroke="#000"
				strokeWidth={0.12}
			/>
			<path d="M320.1 225.75v-.46" fill="none" stroke="#000" strokeWidth={0.13} />
			<path d="M319.85 225.69v-.36" fill="none" stroke="#000" strokeWidth={0.14} />
			<path d="M319.6 225.66v-.27" fill="none" stroke="#000" strokeWidth={0.15} />
			<path d="M319.32 225.6v-.13" fill="none" stroke="#000" strokeWidth={0.18} />
			<path
				d="M326.14 226.1v-1.16m-.58 1.2v-1.23m-.43 1.25v-1.26"
				fill="none"
				stroke="#000"
				strokeWidth={0.01}
			/>
		</svg>
	)
}

export default SvgEs
